import React, { useState, useEffect, useCallback } from 'react';
import InventarioEquipos from '../components/InventarioEquipos';
import { DetalleCliente } from './Clientes';
import ThemeToggle from '../components/ThemeToggle';
import { htmlEscape as htmlEscapeActa, imprimirHTML } from '../lib/acta';

const API = process.env.REACT_APP_API_URL || '';
const token = () => localStorage.getItem('token');
const hdr   = () => ({ Authorization: `Bearer ${token()}` });
const jsonHdr = () => ({ 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` });

const C = {
  bg: '#f3f6fa', accent: '#00b8e3', card: '#ffffff', cardHover: '#f7fbff',
  border: '#d8e4ef', text: '#0b304b', muted: '#7b8fa7',
  green: '#10b981', red: '#ef4444', yellow: '#f59e0b',
};

// ── Reporte semanal PDF ───────────────────────────────────────────
function generarReporteSemanal({ dataSemana, weekStart, weekEnd, metaSemanal, horasSemana, festivosDates, almuerzoPromedio, tecnicoNombre }) {
  const esc = htmlEscapeActa;
  const hF = h => { const n = Math.round(parseFloat(h||0)*60); return `${Math.floor(n/60)}h ${String(n%60).padStart(2,'0')}m`; };
  const fT = v => v ? String(v).slice(0,5) : '—';
  const pct = metaSemanal > 0 ? Math.min(100, Math.round((horasSemana / metaSemanal)*100)) : 100;
  const horasFaltan = Math.max(0, metaSemanal - horasSemana);
  const col = horasSemana >= metaSemanal ? '#10b981' : horasSemana >= metaSemanal*0.9 ? '#ef4444' : horasSemana >= metaSemanal*0.75 ? '#f59e0b' : '#00b8e3';
  const bar = (p, c) => `<div style="height:10px;background:#1e3a50;border-radius:999px;overflow:hidden;margin:6px 0"><div style="width:${p}%;height:100%;background:${c};border-radius:999px"></div></div>`;
  const DIAS = ['Lun','Mar','Mie','Jue','Vie'];
  const dias = []; const d = new Date(`${weekStart}T12:00:00`);
  for (let i = 0; i < 5; i++) {
    const k = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
    const row = dataSemana.find(r => (r.fecha instanceof Date ? r.fecha.toISOString() : String(r.fecha)).slice(0,10) === k);
    dias.push({ k, label: DIAS[i], n: d.getDate(), row, festivo: (festivosDates||new Set()).has(k) });
    d.setDate(d.getDate()+1);
  }
  const festivosN = dias.filter(x=>x.festivo).length;
  const fecha = new Date().toLocaleDateString('es-CO',{day:'numeric',month:'long',year:'numeric'});
  const filas = dias.map(({label,n,row,festivo})=>{
    if (festivo) return `<tr style="background:rgba(245,158,11,0.08)"><td style="padding:8px 10px;font-weight:700">${label} ${n}</td><td colspan="5" style="padding:8px 10px;color:#b45309;font-weight:600">Festivo — dia no laboral</td><td style="padding:8px 10px;font-weight:700;color:#b45309">8h 00m</td></tr>`;
    if (!row) return `<tr style="opacity:0.4"><td style="padding:8px 10px">${label} ${n}</td><td colspan="5" style="padding:8px 10px;color:#7b8fa7">Sin registro</td><td style="padding:8px 10px">—</td></tr>`;
    const hs = parseFloat(row.horas_laborales??row.horas_netas)||0;
    const hc = hs>=8?'#10b981':hs>=7?'#f59e0b':'#ef4444';
    return `<tr style="border-bottom:1px solid #d8e4ef22"><td style="padding:8px 10px;font-weight:700">${label} ${n}</td><td style="padding:8px 10px;color:#10b981">${fT(row.entrada)}</td><td style="padding:8px 10px;color:#f59e0b">${fT(row.salida_almuerzo)}</td><td style="padding:8px 10px;color:#f59e0b">${fT(row.regreso_almuerzo)}</td><td style="padding:8px 10px;color:#ef4444">${fT(row.salida)}</td><td style="padding:8px 10px;color:#7b8fa7">${hF(row.almuerzo_horas||0)}</td><td style="padding:8px 10px;font-weight:700;color:${hc}">${hF(hs)}</td></tr>`;
  }).join('');
  const html = `<!doctype html><html><head><title>Reporte Semanal AGE Informatica</title><style>
    @page{size:A4;margin:15mm}*{box-sizing:border-box}body{font-family:'Segoe UI',Arial,sans-serif;color:#0b304b;margin:0;font-size:12px;background:#f3f6fa}
    .ph{background:#08293f;padding:20px 24px 16px;display:flex;justify-content:space-between;align-items:flex-end}
    .ph h1{font-size:20px;font-weight:900;color:#fff;margin:0 0 3px}.ph .brand{font-size:10px;font-weight:800;letter-spacing:.18em;text-transform:uppercase;color:#00b8e3;margin-bottom:6px}
    .ph .meta{font-size:12px;color:rgba(255,255,255,.55)}.ph-r{text-align:right}.ph-r .ml{font-size:9px;font-weight:800;letter-spacing:.12em;text-transform:uppercase;color:rgba(0,184,227,.6);margin-bottom:2px}.ph-r .mv{font-size:13px;font-weight:700;color:rgba(255,255,255,.8)}
    .abar{height:3px;background:linear-gradient(90deg,#00b8e3,#0077a8);margin-bottom:20px}
    .kpis{display:grid;grid-template-columns:repeat(3,1fr);gap:12px;margin-bottom:20px}
    .kpi{background:#fff;border:1px solid #d8e4ef;border-radius:10px;padding:14px 16px}
    .kl{font-size:9px;font-weight:800;text-transform:uppercase;letter-spacing:.1em;color:#7b8fa7;margin-bottom:8px}
    .kv{font-size:28px;font-weight:900;line-height:1}.kd{font-size:11px;color:#7b8fa7;margin-top:6px}
    table{width:100%;border-collapse:collapse;background:#fff;border-radius:10px;overflow:hidden;border:1px solid #d8e4ef}
    th{padding:9px 10px;text-align:left;color:#7b8fa7;font-weight:700;font-size:10px;text-transform:uppercase;letter-spacing:.5px;border-bottom:1px solid #d8e4ef;background:#f7fafc}
    .ft{margin-top:16px;text-align:center;font-size:10px;color:#7b8fa7}
    @media print{body{background:#fff}}
  </style></head><body>
  <div class="ph"><div><div class="brand">AGE Informatica &middot; Tecnico</div><h1>Reporte Semanal</h1><div class="meta">Semana: ${esc(weekStart)} &mdash; ${esc(weekEnd)}${tecnicoNombre?` &nbsp;&bull;&nbsp; ${esc(tecnicoNombre)}`:''}</div></div><div class="ph-r"><div class="ml">Generado</div><div class="mv">${esc(fecha)}</div></div></div>
  <div class="abar"></div>
  <div class="kpis">
    <div class="kpi"><div class="kl">Horas cumplidas</div><div class="kv" style="color:${col}">${hF(horasSemana)}</div>${bar(pct,col)}<div class="kd">${pct}% de ${hF(metaSemanal)} meta${festivosN>0?` &mdash; ${festivosN} festivo${festivosN>1?'s':''}`:''}  </div></div>
    <div class="kpi"><div class="kl">Almuerzo promedio</div><div class="kv" style="color:#f59e0b">${hF(almuerzoPromedio)}</div><div class="kd" style="margin-top:20px">Tiempo fuera del dia</div></div>
    <div class="kpi"><div class="kl">Horas faltantes</div><div class="kv" style="color:${horasFaltan===0?'#10b981':'#ef4444'}">${hF(horasFaltan)}</div><div class="kd" style="margin-top:20px">${horasFaltan===0?'Meta semanal cumplida':'Para completar la semana'}</div></div>
  </div>
  <table><thead><tr><th>Dia</th><th>Entrada</th><th>Sal. Alm.</th><th>Reg. Alm.</th><th>Salida</th><th>T. Alm.</th><th>Horas lab.</th></tr></thead>
  <tbody>${filas}</tbody>
  <tfoot><tr style="background:#f7fafc;border-top:2px solid #d8e4ef"><td colspan="6" style="padding:9px 10px;font-weight:800;text-align:right">Total semana:</td><td style="padding:9px 10px;font-weight:900;font-size:14px;color:${col}">${hF(horasSemana)}</td></tr></tfoot></table>
  <div class="ft">AGE Informatica &middot; info@ageinformatica.com &middot; 313 3030874</div>
  <script>window.onload=()=>setTimeout(()=>window.print(),300)</script></body></html>`;
  imprimirHTML(html);
}

function textoReporteSemanal({ dataSemana, weekStart, weekEnd, metaSemanal, horasSemana, festivosDates, almuerzoPromedio, tecnicoNombre }) {
  const hF = h => { const n = Math.round(parseFloat(h||0)*60); return `${Math.floor(n/60)}h${String(n%60).padStart(2,'0')}m`; };
  const fT = v => v ? String(v).slice(0,5) : '--';
  const pct = metaSemanal > 0 ? Math.min(100, Math.round((horasSemana/metaSemanal)*100)) : 100;
  const horasFaltan = Math.max(0, metaSemanal - horasSemana);
  const bloques = Math.round(pct/10);
  const barra = '▓'.repeat(bloques) + '░'.repeat(10-bloques);
  const DIAS = ['Lun','Mar','Mie','Jue','Vie'];
  const dias = []; const d = new Date(`${weekStart}T12:00:00`);
  for (let i = 0; i < 5; i++) {
    const k = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
    const row = dataSemana.find(r => (r.fecha instanceof Date ? r.fecha.toISOString() : String(r.fecha)).slice(0,10) === k);
    dias.push({ label: DIAS[i], n: d.getDate(), row, festivo: (festivosDates||new Set()).has(k) });
    d.setDate(d.getDate()+1);
  }
  const lineas = dias.map(({label,n,row,festivo}) => {
    if (festivo) return `${label} ${n}: Festivo`;
    if (!row) return `${label} ${n}: Sin registro`;
    const hs = parseFloat(row.horas_laborales??row.horas_netas)||0;
    return `${label} ${n}: ${fT(row.entrada)} → ${fT(row.salida)} | ${hF(hs)}`;
  });
  return `*Reporte Semanal AGE Informatica*\n${weekStart} — ${weekEnd}${tecnicoNombre?'\n'+tecnicoNombre:''}\n\n*Horas cumplidas*\n${barra} ${hF(horasSemana)} / ${hF(metaSemanal)} (${pct}%)\n\n*Almuerzo promedio:* ${hF(almuerzoPromedio)}\n*Horas faltantes:* ${horasFaltan>0?hF(horasFaltan):'Cumplida'}\n\n*Detalle diario*\n${lineas.join('\n')}\n\n_AGE Informatica_`;
}

const s = {
  page:    { minHeight: '100vh', background: C.bg, color: C.text, fontFamily: "'Space Grotesk', sans-serif", padding: '0 0 60px' },
  header:  { background: '#0a3048', borderBottom: '1px solid #08293f', padding: '16px 24px', display: 'flex', alignItems: 'center', gap: 16 },
  tabs:    (emb) => ({ display: 'flex', gap: 2, background: emb ? 'transparent' : '#f3f6fa', padding: emb ? 0 : '18px 24px 0', borderBottom: '1px solid var(--app-border)', marginBottom: emb ? 16 : 0 }),
  tab:     (a)  => ({ padding: '8px 16px', border: 'none', cursor: 'pointer', fontFamily: 'inherit', fontSize: 12, fontWeight: 600, letterSpacing: '0.04em', background: 'transparent', color: a ? 'var(--app-heading)' : 'var(--app-muted)', borderBottom: a ? '2px solid #00b8e3' : '2px solid transparent', marginBottom: -1 }),
  wrap:    { maxWidth: 900, margin: '0 auto', padding: '24px 16px' },
  card:    { background: C.card, border: `1px solid ${C.border}`, borderRadius: 12, padding: 20, marginBottom: 16 },
  secTitle:{ fontSize: 13, fontWeight: 700, color: C.muted, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 12 },
  btn:  (bg = C.accent) => ({ padding: '10px 18px', borderRadius: 8, border: 'none', background: bg, color: '#fff', fontWeight: 600, fontSize: 14, cursor: 'pointer', fontFamily: 'inherit' }),
  btnSm:(bg = C.accent) => ({ padding: '6px 12px', borderRadius: 6, border: 'none', background: bg, color: '#fff', fontWeight: 600, fontSize: 12, cursor: 'pointer', fontFamily: 'inherit' }),
  input:   { padding: '8px 12px', borderRadius: 8, border: `1px solid ${C.border}`, background: '#fff', color: C.text, fontSize: 14, fontFamily: 'inherit', width: '100%', boxSizing: 'border-box' },
  select:  { padding: '8px 12px', borderRadius: 8, border: `1px solid ${C.border}`, background: '#fff', color: C.text, fontSize: 14, fontFamily: 'inherit', width: '100%', boxSizing: 'border-box' },
  label:   { fontSize: 12, color: C.muted, marginBottom: 4, display: 'block' },
  row:     { display: 'flex', gap: 12, flexWrap: 'wrap' },
};

function useViewportWidth() {
  const getWidth = () => (typeof window === 'undefined' ? 1130 : window.innerWidth);
  const [width, setWidth] = useState(getWidth);
  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const onResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return width;
}

function CopyBtn({ text }) {
  const [ok, setOk] = useState(false);
  const copy = () => { navigator.clipboard?.writeText(text); setOk(true); setTimeout(() => setOk(false), 1500); };
  return (
    <button onClick={copy} title="Copiar" style={{ background: ok ? 'rgba(16,185,129,0.2)' : 'rgba(0,184,227,0.1)', border: `1px solid ${ok ? 'rgba(16,185,129,0.4)' : 'rgba(0,184,227,0.25)'}`, borderRadius: 6, cursor: 'pointer', color: ok ? '#10b981' : '#00b8e3', fontSize: 11, fontWeight: 700, padding: '3px 8px', whiteSpace: 'nowrap', transition: 'all 0.2s' }}>
      {ok ? '✓ Copiado' : '📋 Copiar'}
    </button>
  );
}

const TIPOS = ['entrada','salida_almuerzo','regreso_almuerzo','salida','llegada_empresa','salida_empresa'];
const TIPO_LABEL = { entrada:'Entrada', salida:'Salida del dia', salida_almuerzo:'Salida almuerzo', regreso_almuerzo:'Regreso almuerzo', llegada_empresa:'Desplazamiento', salida_empresa:'Salida empresa' };
const TIPO_ICON  = { entrada:'▶', salida:'■', salida_almuerzo:'🍽', regreso_almuerzo:'↩', llegada_empresa:'🏢', salida_empresa:'🚗' };

function fmtTime(val) {
  if (!val) return '—';
  // Si es solo HH:MM:SS o HH:MM, construir fecha dummy para parsear
  if (typeof val === 'string' && /^\d{2}:\d{2}/.test(val)) {
    return val.slice(0, 5); // simplemente mostrar HH:MM
  }
  const d = new Date(val);
  if (isNaN(d)) return val;
  return d.toLocaleTimeString('es-CO', { hour: '2-digit', minute: '2-digit' });
}
function fmtDate(iso) { if (!iso) return '—'; return new Date(iso).toLocaleDateString('es-CO', { weekday: 'short', day: 'numeric', month: 'short' }); }
// Handles both Date objects and "YYYY-MM-DD" strings from mysql2
function safeDate(f) { if (!f) return ''; return f instanceof Date ? f.toISOString().slice(0,10) : String(f).slice(0,10); }
function toLocalInput(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
  return d.toISOString().slice(0, 16);
}

// ─── Tab Registro (técnico) ──────────────────────────────────────────────────

function useClock() {
  const [now, setNow] = useState(new Date());
  useEffect(() => { const t = setInterval(() => setNow(new Date()), 1000); return () => clearInterval(t); }, []);
  return now;
}

function useRed() {
  const [red, setRed] = useState(null);
  useEffect(() => {
    const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    const actualizar = () => {
      if (!conn) { setRed(null); return; }
      if (conn.type === 'wifi') setRed({ tipo: 'wifi', label: 'WiFi' });
      else if (conn.type === 'cellular') setRed({ tipo: 'celular', label: 'Datos móviles' });
      else if (conn.effectiveType) setRed({ tipo: 'red', label: conn.effectiveType.toUpperCase() });
      else setRed(null);
    };
    actualizar();
    conn?.addEventListener('change', actualizar);
    return () => conn?.removeEventListener('change', actualizar);
  }, []);
  return red;
}

// ─── Mi semana: horas cumplidas vs meta ──────────────────────────────────────
// Horario del tecnico en minutos desde medianoche (1 = lunes ... 5 = viernes).
// Lunes a jueves 07:00-16:30 con 15 min de almuerzo (9h15), viernes 07:00-12:00 (5h). Total 42h.
const HORARIO_TECNICO = {
  1: { s: 420, e: 990, l: 15 }, 2: { s: 420, e: 990, l: 15 }, 3: { s: 420, e: 990, l: 15 },
  4: { s: 420, e: 990, l: 15 }, 5: { s: 420, e: 720, l: 0 },
};
const TOLERANCIA_MIN = 5;
const ALMUERZO_DESDE_MIN = 13 * 60 + 30;
const metaDiaMin = dow => { const h = HORARIO_TECNICO[dow]; return h ? h.e - h.s - h.l : 0; };
// Festivo: descuenta las horas de ese dia (9h15 lunes a jueves, 5h viernes)
const metaSemanaHoras = (fechasFestivo) => {
  const base = [1, 2, 3, 4, 5].reduce((a, d) => a + metaDiaMin(d), 0);
  const menos = fechasFestivo.reduce((a, f) => a + metaDiaMin(new Date(`${f}T12:00:00`).getDay()), 0);
  return Math.max(0, base - menos) / 60;
};

const DIA_LETRA  = ['', 'L', 'M', 'X', 'J', 'V'];
const DIA_NOMBRE = ['', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes'];
const minDe = t => { if (!t) return null; const [h, m] = String(t).split(':').map(Number); return Number.isNaN(h) ? null : h * 60 + (m || 0); };
const hhmm = n => `${String(Math.floor(n / 60)).padStart(2, '0')}:${String(n % 60).padStart(2, '0')}`;
const durFmt = n => { n = Math.round(Math.abs(n)); const h = Math.floor(n / 60), m = n % 60; return h ? (m ? `${h}h ${String(m).padStart(2, '0')}m` : `${h}h`) : `${m} min`; };
const sumarDias = (iso, n) => { const d = new Date(`${iso}T12:00:00Z`); d.setUTCDate(d.getUTCDate() + n); return d.toISOString().slice(0, 10); };
const RAYADO_ROJO = 'repeating-linear-gradient(-45deg, rgba(239,68,68,.55) 0 3px, rgba(239,68,68,.12) 3px 6px)';
const CALLOUT = {
  red:    { background: '#fde9e9', color: '#8f1f1f' },
  yellow: { background: '#fdf3e1', color: '#7a4a03' },
  green:  { background: '#e2f7ee', color: '#0a5c40' },
  blue:   { background: '#e3f6fb', color: '#075469' },
};

function evaluarDia({ fecha, dow, ev, esHoy, esFuturo, esFestivo, ahora }) {
  const h = HORARIO_TECNICO[dow], meta = metaDiaMin(dow);
  if (esFestivo) return { estado: 'festivo', trabajado: 0, meta: 0, metaHorario: meta, fecha, dow };
  if (esFuturo) return { estado: 'futuro', trabajado: 0, meta, fecha, dow };
  const ent = minDe(ev?.entrada);
  if (ent === null) {
    if (esHoy) return { estado: 'sin-entrada', trabajado: 0, meta, fecha, dow, h, retraso: Math.max(0, ahora - h.s) };
    return { estado: 'ausente', trabajado: 0, meta, fecha, dow };
  }
  const ls = minDe(ev.salida_almuerzo), lr = minDe(ev.regreso_almuerzo), sal = minDe(ev.salida);
  const tarde = ent - h.s > TOLERANCIA_MIN ? ent - h.s : 0;
  const almuerzo = ls !== null && lr !== null && lr > ls ? lr - ls : 0;
  const enAlmuerzo = ls !== null && lr === null;
  const base = { fecha, dow, h, ev, ent, ls, tarde, almuerzo, meta };
  if (sal !== null) {
    const trabajado = Math.max(0, sal - ent - almuerzo);
    return { ...base, estado: trabajado >= meta - TOLERANCIA_MIN ? 'completo' : 'corto', trabajado };
  }
  if (esHoy) {
    const hasta = enAlmuerzo ? ls : ahora;
    return { ...base, estado: enAlmuerzo ? 'almuerzo' : 'curso', enAlmuerzo, trabajado: Math.max(0, hasta - ent - almuerzo) };
  }
  // Sin salida: el consolidado lo cuenta en 0. Se estima lo que habria contado saliendo a su hora.
  return { ...base, estado: 'sin-salida', trabajado: 0, estimado: Math.max(0, h.e - ent - (almuerzo || h.l)) };
}

function MiSemanaCard({ usuarioId, nombre, refreshKey, now }) {
  const [data, setData] = useState(null);
  const [sel, setSel] = useState(null);

  const cargar = useCallback(() => {
    const qs = usuarioId ? `?usuario_id=${encodeURIComponent(usuarioId)}` : '';
    fetch(`${API}/api/tecnico/mi-semana${qs}`, { headers: hdr() })
      .then(r => (r.ok ? r.json() : null))
      .then(d => { if (d && d.desde) setData(d); })
      .catch(() => {});
  }, [usuarioId]);

  useEffect(() => {
    cargar();
    const t = setInterval(cargar, 60000);
    return () => clearInterval(t);
  }, [cargar, refreshKey]);

  if (!data) return null;

  // Hora de Colombia (UTC-5) en minutos, independiente de la zona del celular
  const ahora = ((now.getUTCHours() * 60 + now.getUTCMinutes()) - 300 + 1440) % 1440;
  const fechas = [0, 1, 2, 3, 4].map(i => sumarDias(data.desde, i));
  const idxHoy = fechas.indexOf(data.hoy);
  const enCurso = idxHoy >= 0;
  const festivos = new Set((data.festivos || []).map(f => f.fecha));
  const dias = fechas.map((fecha, i) => evaluarDia({
    fecha, dow: i + 1,
    ev: (data.dias || []).find(d => d.fecha === fecha),
    esHoy: i === idxHoy, esFuturo: enCurso && i > idxHoy, esFestivo: festivos.has(fecha), ahora,
  }));
  const meta = dias.reduce((a, d) => a + d.meta, 0);
  const contado = dias.reduce((a, d) => a + d.trabajado, 0);
  const sinContar = dias.reduce((a, d) => a + (d.estimado || 0), 0);
  const nSinSalida = dias.filter(d => d.estado === 'sin-salida').length;

  let esperado = meta;
  let pill, mensaje;
  if (enCurso) {
    const hHoy = HORARIO_TECNICO[idxHoy + 1];
    let espHoy = 0;
    if (ahora > hHoy.s) {
      espHoy = Math.min(ahora, hHoy.e) - hHoy.s;
      if (hHoy.l && ahora > ALMUERZO_DESDE_MIN) espHoy -= Math.min(hHoy.l, ahora - ALMUERZO_DESDE_MIN);
    }
    esperado = dias.reduce((a, d, i) => a + (i < idxHoy ? d.meta : 0), 0) + (dias[idxHoy].estado === 'festivo' ? 0 : Math.max(0, espHoy));
    const dif = contado - esperado;
    pill = dif >= -TOLERANCIA_MIN ? { tipo: 'ok', txt: dif > TOLERANCIA_MIN ? `${durFmt(dif)} arriba` : 'Al día' }
      : dif >= -30 ? { tipo: 'warn', txt: `${durFmt(dif)} abajo` } : { tipo: 'bad', txt: `${durFmt(dif)} abajo` };
    mensaje = esperado === 0 ? <>Tu jornada empieza a las <b>{hhmm(hHoy.s)}</b>.</>
      : dif >= -TOLERANCIA_MIN ? <>A esta hora deberías llevar <b>{durFmt(esperado)}</b>. Vas bien.</>
      : <>A esta hora deberías llevar <b>{durFmt(esperado)}</b>. Te faltan <b>{durFmt(-dif)}</b> para estar al día.</>;
  } else {
    const dif = contado - meta;
    pill = dif >= -TOLERANCIA_MIN ? { tipo: 'ok', txt: 'Meta cumplida' } : { tipo: 'bad', txt: `Faltaron ${durFmt(dif)}` };
    mensaje = dif >= -TOLERANCIA_MIN ? <>Cumpliste las horas de la semana.</> : <>Quedaste <b>{durFmt(-dif)}</b> por debajo de la meta.</>;
  }
  if (nSinSalida > 0) {
    mensaje = <>{mensaje} <b style={{ color: '#c23030' }}>{nSinSalida} {nSinSalida > 1 ? 'días' : 'día'} sin salida marcada</b>: esas horas no cuentan (serían cerca de {durFmt(sinContar)} más). Pide al administrador que corrija la salida.</>;
  }
  const PILL = { ok: { background: '#e3f8ef', color: '#0b7a55' }, warn: { background: '#fdf1dc', color: '#a36404' }, bad: { background: '#fde6e6', color: '#c23030' } };

  // Proyeccion: lo contado + lo que falta hoy hasta su hora de salida + los dias que vienen
  let pie;
  if (enCurso) {
    const d = dias[idxHoy];
    let restoHoy = 0;
    if (d.estado === 'curso') restoHoy = Math.max(0, d.h.e - ahora - (d.ls === null && d.h.l && ahora < ALMUERZO_DESDE_MIN + d.h.l ? d.h.l : 0));
    else if (d.estado === 'almuerzo') restoHoy = Math.max(0, d.h.e - Math.max(ahora, d.ls + d.h.l));
    else if (d.estado === 'sin-entrada') restoHoy = Math.max(0, d.h.e - Math.max(ahora, d.h.s) - d.h.l);
    const futuro = dias.reduce((a, x, i) => a + (i > idxHoy ? x.meta : 0), 0);
    const proyeccion = contado + restoHoy + futuro;
    const brecha = meta - proyeccion;
    pie = <>Te faltan <b>{durFmt(Math.max(0, meta - contado))}</b> para la meta. {brecha > TOLERANCIA_MIN
      ? <>Si sales a tu hora todos los días, cierras la semana en <b>{durFmt(proyeccion)}</b>, <b style={{ color: '#c23030' }}>{durFmt(brecha)} por debajo</b>. Recupéralos saliendo más tarde algún día.</>
      : <>Si sales a tu hora todos los días, cumples la meta.</>}</>;
  } else {
    pie = <>Semana cerrada. Contadas <b>{durFmt(contado)}</b> de <b>{durFmt(meta)}</b>.</>;
  }

  const pct = v => (meta ? Math.min(100, (v / meta) * 100) : 0);
  const selIdx = sel && sel.desde === data.desde ? sel.i
    : enCurso ? idxHoy : Math.max(0, dias.findIndex(d => d.estado === 'sin-salida'));
  const fmtRango = `${Number(data.desde.slice(8))} – ${Number(data.hasta.slice(8))} ${new Date(`${data.hasta}T12:00:00`).toLocaleDateString('es-CO', { month: 'short' }).replace('.', '')}`;
  const callout = (tipo, contenido) => <div style={{ ...CALLOUT[tipo], fontSize: 13, borderRadius: 8, padding: '9px 10px', lineHeight: 1.45 }}>{contenido}</div>;

  const detalle = (d, i) => {
    const titulo = `${DIA_NOMBRE[d.dow]} ${Number(d.fecha.slice(8))}${i === idxHoy ? ' · hoy' : ''}`;
    const sub = d.estado === 'festivo' ? 'Festivo' : `Meta del día ${durFmt(d.meta)}`;
    const head = <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 8 }}><b style={{ fontSize: 14 }}>{titulo}</b><span style={{ fontSize: 12, color: C.muted }}>{sub}</span></div>;
    const partes = [head];
    if (d.estado === 'festivo') partes.push(callout('blue', <>Día festivo{(data.festivos || []).find(f => f.fecha === d.fecha)?.descripcion ? ` (${data.festivos.find(f => f.fecha === d.fecha).descripcion})` : ''}. La meta de la semana baja {durFmt(d.metaHorario)}.</>));
    else if (d.estado === 'futuro') { const h = HORARIO_TECNICO[d.dow]; partes.push(callout('blue', <>Horario: {hhmm(h.s)} a {hhmm(h.e)}{h.l ? `, con ${h.l} min de almuerzo` : ''}.</>)); }
    else if (d.estado === 'ausente') partes.push(callout('red', <>No hay marcaciones este día.</>));
    else if (d.estado === 'sin-entrada') partes.push(d.retraso > TOLERANCIA_MIN
      ? callout('red', <><b>Aún no marcas entrada.</b> Tu jornada empezó a las {hhmm(d.h.s)} y ya van {durFmt(d.retraso)}.</>)
      : callout('blue', <>Tu jornada empieza a las {hhmm(d.h.s)}. Marca la entrada al llegar.</>));
    else {
      const almTxt = d.ev.salida_almuerzo ? `${fmtTime(d.ev.salida_almuerzo)}–${d.ev.regreso_almuerzo ? fmtTime(d.ev.regreso_almuerzo) : '…'}` : '—';
      const salTxt = d.ev.salida ? fmtTime(d.ev.salida) : d.estado === 'sin-salida' ? 'sin marcar' : 'en curso';
      const marca = (lbl, val, color) => <div style={{ display: 'grid', gap: 1 }}><span style={{ fontSize: 10.5, color: C.muted, textTransform: 'uppercase', letterSpacing: '.04em' }}>{lbl}</span><strong style={{ fontSize: 14, color, fontVariantNumeric: 'tabular-nums' }}>{val}</strong></div>;
      partes.push(<div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0,1fr))', gap: 6 }}>
        {marca('Entrada', fmtTime(d.ev.entrada), d.tarde ? '#c23030' : '#0b7a55')}
        {marca('Almuerzo', almTxt, C.text)}
        {marca('Salida', salTxt, d.ev.salida ? C.text : '#c23030')}
      </div>);
      const etiqueta = d.estado === 'curso' ? 'llevas hoy' : d.estado === 'almuerzo' ? 'llevas hoy (en almuerzo, el contador está en pausa)' : d.estado === 'sin-salida' ? 'contadas' : 'trabajadas';
      partes.push(<div style={{ display: 'flex', alignItems: 'baseline', gap: 6, flexWrap: 'wrap' }}>
        <span style={{ fontSize: 24, fontWeight: 800, fontVariantNumeric: 'tabular-nums' }}>{d.estado === 'sin-salida' ? '0h' : durFmt(d.trabajado)}</span>
        <span style={{ fontSize: 13, color: C.muted }}>{etiqueta} de {durFmt(d.meta)}</span>
      </div>);
      if (d.estado === 'curso' || d.estado === 'almuerzo') {
        const almUsado = d.h.l ? (d.almuerzo || (d.enAlmuerzo ? Math.max(d.h.l, ahora - d.ls) : d.h.l)) : 0;
        const salir = d.ent + d.meta + almUsado;
        const aSuHora = Math.max(0, d.h.e - d.ent - almUsado);
        if (d.tarde) partes.push(callout('red', <><b>Llegaste {durFmt(d.tarde)} tarde.</b> Para completar tus {durFmt(d.meta)} de hoy debes salir a las <b>{hhmm(salir)}</b>. Si sales a las {hhmm(d.h.e)}, el día queda en {durFmt(aSuHora)}, faltando {durFmt(d.meta - aSuHora)}.</>));
        else partes.push(callout('green', <>Llegaste a tiempo. Completas el día saliendo a las <b>{hhmm(salir)}</b>.</>));
        if (d.estado === 'curso' && ahora > d.h.e + 15) partes.push(callout('yellow', <>Ya pasó tu hora de salida. Recuerda marcar <b>Salida del día</b>: si no la marcas, las horas de hoy no cuentan.</>));
      } else if (d.estado === 'sin-salida') {
        partes.push(callout('red', <><b>No marcaste salida.</b> Estas horas no cuentan para la semana. Si salías a las {hhmm(d.h.e)} serían unas <b>{durFmt(d.estimado)}</b>. Pide al administrador que corrija la salida.</>));
      } else {
        const dif = d.trabajado - d.meta;
        if (d.tarde && dif < -TOLERANCIA_MIN) partes.push(callout('red', <>Llegaste {durFmt(d.tarde)} tarde y el día quedó en {durFmt(d.trabajado)}: faltaron <b>{durFmt(-dif)}</b>.</>));
        else if (d.tarde) partes.push(callout('yellow', <>Llegaste {durFmt(d.tarde)} tarde, pero compensaste: {durFmt(d.trabajado)} de {durFmt(d.meta)}.</>));
        else if (dif < -TOLERANCIA_MIN) partes.push(callout('yellow', <>El día quedó en {durFmt(d.trabajado)}: faltaron <b>{durFmt(-dif)}</b>.</>));
        else partes.push(callout('green', <>Día completo{dif > TOLERANCIA_MIN ? `, con ${durFmt(dif)} extra` : ''}.</>));
        if (d.almuerzo > 60) partes.push(callout('yellow', <>Almuerzo de {durFmt(d.almuerzo)}. ¿Olvidaste marcar el regreso?</>));
      }
    }
    return <div style={{ background: '#f7fafd', border: `1px solid ${C.border}`, borderRadius: 10, padding: 12, display: 'grid', gap: 8 }}>
      {partes.map((p, k) => <React.Fragment key={k}>{p}</React.Fragment>)}
    </div>;
  };

  const colorDia = ['#00b8e3', '#0a93b8', '#00b8e3', '#0a93b8', '#00b8e3'];
  const enVivo = d => d.estado === 'curso' || d.estado === 'almuerzo';

  return (
    <div style={{ ...s.card, border: `1px solid ${C.accent}`, display: 'grid', gap: 12 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 8 }}>
        <div style={{ ...s.secTitle, marginBottom: 0 }}>{nombre ? `Semana de ${nombre}` : 'Mi semana'}</div>
        <span style={{ fontSize: 12, color: C.muted }}>{fmtRango}{enCurso ? '' : ' · cerrada'}</span>
      </div>

      <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, flexWrap: 'wrap' }}>
        <span style={{ fontSize: 32, fontWeight: 800, lineHeight: 1, fontVariantNumeric: 'tabular-nums' }}>{durFmt(contado)}</span>
        <span style={{ fontSize: 14, color: C.muted }}>de {durFmt(meta)}</span>
        <span style={{ ...PILL[pill.tipo], marginLeft: 'auto', fontSize: 11.5, fontWeight: 700, padding: '3px 9px', borderRadius: 99, whiteSpace: 'nowrap' }}>{pill.txt}</span>
      </div>

      <div style={{ marginTop: enCurso && esperado > 0 ? 12 : 0 }}>
        <div style={{ position: 'relative', height: 16, borderRadius: 6, background: '#e8eef4', display: 'flex' }}>
          {dias.map((d, i) => d.trabajado > 0 && (
            <div key={`t${i}`} title={`${DIA_NOMBRE[d.dow]}: ${durFmt(d.trabajado)}`} style={{
              width: `${pct(d.trabajado)}%`, height: '100%', borderRight: '2px solid #fff',
              borderRadius: i === dias.findIndex(x => x.trabajado > 0) ? '6px 0 0 6px' : 0,
              backgroundColor: d.estado === 'corto' ? C.yellow : colorDia[i],
              backgroundImage: enVivo(d) ? 'repeating-linear-gradient(-45deg, rgba(255,255,255,.35) 0 5px, transparent 5px 10px)' : 'none',
            }} />
          ))}
          {dias.map((d, i) => d.estimado > 0 && (
            <div key={`g${i}`} title={`${DIA_NOMBRE[d.dow]}: sin salida, ~${durFmt(d.estimado)} sin contar`}
              style={{ width: `${pct(d.estimado)}%`, height: '100%', borderRight: '2px solid #fff', background: RAYADO_ROJO }} />
          ))}
          {enCurso && esperado > 0 && (
            <div style={{ position: 'absolute', top: -5, bottom: -5, left: `${pct(esperado)}%`, width: 2, background: '#08293f', transform: 'translateX(-1px)' }}>
              <span style={{ position: 'absolute', top: -17, left: '50%', transform: 'translateX(-50%)', fontSize: 10, fontWeight: 700, color: '#08293f', whiteSpace: 'nowrap' }}>deberías ir aquí</span>
            </div>
          )}
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 10.5, color: C.muted, marginTop: 3 }}><span>0h</span><span>{durFmt(meta)}</span></div>
      </div>

      <div style={{ fontSize: 13, lineHeight: 1.45 }}>{mensaje}</div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, minmax(0,1fr))', gap: 6 }}>
        {dias.map((d, i) => {
          const H = 54;
          let barra, horas, flag = '', flagColor = C.muted;
          if (d.estado === 'futuro') {
            barra = <div style={{ width: 20, height: H, borderRadius: 5, border: `1.5px dashed ${C.border}`, boxSizing: 'border-box' }} />;
            horas = durFmt(d.meta); flag = 'meta';
          } else if (d.estado === 'festivo') {
            barra = <div style={{ width: 20, height: H, borderRadius: 5, background: 'repeating-linear-gradient(0deg, #e5e7eb 0 3px, #f3f4f6 3px 6px)' }} />;
            horas = '—'; flag = 'Festivo';
          } else {
            const mostrado = d.estimado || d.trabajado;
            const alto = Math.min(H, (mostrado / (d.meta * 1.1)) * H);
            const fondo = d.estado === 'sin-salida' ? RAYADO_ROJO : d.estado === 'corto' ? C.yellow : d.estado === 'completo' ? C.green : C.accent;
            barra = <div style={{ position: 'relative', width: 20, height: H, borderRadius: 5, background: '#e8eef4', overflow: 'hidden' }}>
              <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0, height: alto, background: fondo, borderRadius: '5px 5px 0 0' }} />
              <div style={{ position: 'absolute', left: -2, right: -2, bottom: H / 1.1, borderTop: '1.5px dashed #08293f', opacity: 0.45 }} />
            </div>;
            horas = d.estado === 'sin-salida' ? '0h' : durFmt(d.trabajado);
            if (d.estado === 'sin-salida') { flag = 'Sin salida'; flagColor = '#c23030'; }
            else if (d.estado === 'ausente') { flag = 'Sin marcar'; flagColor = '#c23030'; }
            else if (d.estado === 'sin-entrada') { flag = d.retraso > TOLERANCIA_MIN ? 'Sin entrada' : 'Hoy'; flagColor = d.retraso > TOLERANCIA_MIN ? '#c23030' : '#007f9e'; }
            else if (d.tarde) { flag = `Tarde ${d.tarde}m`; flagColor = '#c23030'; }
            else if (enVivo(d)) { flag = 'Hoy'; flagColor = '#007f9e'; }
            else if (d.estado === 'completo') { flag = 'Cumplido'; flagColor = '#0b7a55'; }
            else if (d.estado === 'corto') { flag = `−${durFmt(d.meta - d.trabajado)}`; flagColor = '#a36404'; }
          }
          const activo = i === selIdx;
          return (
            <button key={d.fecha} type="button" onClick={() => setSel({ desde: data.desde, i })}
              aria-pressed={activo} aria-label={`${DIA_NOMBRE[d.dow]} ${Number(d.fecha.slice(8))}: ${horas} ${flag}`}
              style={{ fontFamily: 'inherit', color: C.text, background: activo ? '#eaf9fd' : '#f7fafd', border: `1px solid ${activo ? C.accent : C.border}`, borderRadius: 10, padding: '6px 2px 7px', cursor: 'pointer', display: 'grid', justifyItems: 'center', gap: 3, minWidth: 0 }}>
              <span style={{ fontSize: 11, fontWeight: 700, color: C.muted }}>{DIA_LETRA[d.dow]}</span>
              <span style={{ fontSize: 10, color: C.muted }}>{Number(d.fecha.slice(8))}</span>
              {barra}
              <span style={{ fontSize: 11, fontWeight: 700, fontVariantNumeric: 'tabular-nums' }}>{horas}</span>
              <span style={{ fontSize: 9.5, fontWeight: 700, lineHeight: 1.15, textAlign: 'center', minHeight: 11, color: flagColor }}>{flag}</span>
            </button>
          );
        })}
      </div>

      {detalle(dias[selIdx], selIdx)}

      <div style={{ fontSize: 12.5, color: C.muted, borderTop: `1px solid ${C.border}`, paddingTop: 10, lineHeight: 1.45 }}>{pie}</div>
    </div>
  );
}

function TabRegistro({ isAdmin }) {
  const [hoy,       setHoy]       = useState(null);
  const [empresas,  setEmpresas]  = useState([]);
  const [usuariosRegistro, setUsuariosRegistro] = useState([]);
  const [usuarioEmpresasId, setUsuarioEmpresasId] = useState('');
  const [empresaSel,setEmpresaSel]= useState('');
  const [gps,       setGps]       = useState(null);
  const [gpsPermiso,setGpsPermiso]= useState('unknown');
  const [gpsLoading,setGpsLoading]= useState(false);
  const [msg,       setMsg]       = useState('');
  const [loading,   setLoading]   = useState(false);
  const [semanaKey, setSemanaKey] = useState(0);
  const now = useClock();
  const red = useRed();

  const cargarUsuariosRegistro = useCallback(() => {
    if (!isAdmin) return;
    fetch(`${API}/api/usuarios/tecnicos`, { headers: hdr() })
      .then(r => r.json())
      .then(d => {
        const list = Array.isArray(d) ? d.filter(u => u.rol === 'tecnico') : [];
        setUsuariosRegistro(list);
        setUsuarioEmpresasId(prev => prev || String(list[0]?.id || ''));
      }).catch(() => {});
  }, [isAdmin]);

  const cargarDatos = useCallback(() => {
    fetch(`${API}/api/tecnico/hoy`, { headers: hdr() }).then(r => r.json()).then(setHoy).catch(() => {});
    const qs = isAdmin && usuarioEmpresasId ? `?usuario_id=${encodeURIComponent(usuarioEmpresasId)}` : '';
    fetch(`${API}/api/empresas-lista${qs}`, { headers: hdr() })
      .then(r => r.json())
      .then(d => { setEmpresas(Array.isArray(d) ? d : []); setEmpresaSel(''); })
      .catch(() => {});
  }, [isAdmin, usuarioEmpresasId]);

  useEffect(() => { cargarUsuariosRegistro(); }, [cargarUsuariosRegistro]);
  useEffect(() => { if (!isAdmin || usuarioEmpresasId) cargarDatos(); }, [cargarDatos, isAdmin, usuarioEmpresasId]);

  const solicitarGps = useCallback((opts = {}) => new Promise(resolve => {
    if (!navigator.geolocation) { setGps('no'); setGpsPermiso('unsupported'); resolve(null); return; }
    setGpsLoading(true);
    navigator.geolocation.getCurrentPosition(
      pos => {
        const coords = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        setGps(coords);
        setGpsPermiso('granted');
        setGpsLoading(false);
        resolve(coords);
      },
      () => {
        setGps('denied');
        setGpsPermiso('denied');
        setGpsLoading(false);
        resolve(null);
      },
      { timeout: opts.timeout || 10000, maximumAge: opts.maximumAge || 0, enableHighAccuracy: true }
    );
  }), []);

  const consultarPermisoGps = useCallback(async () => {
    if (!navigator.geolocation) { setGps('no'); setGpsPermiso('unsupported'); return; }
    if (!navigator.permissions?.query) { setGps('prompt'); setGpsPermiso('prompt'); return; }
    try {
      const status = await navigator.permissions.query({ name: 'geolocation' });
      setGpsPermiso(status.state);
      if (status.state === 'granted') solicitarGps({ maximumAge: 60000 });
      else setGps(status.state === 'denied' ? 'denied' : 'prompt');
      status.onchange = () => {
        setGpsPermiso(status.state);
        if (status.state === 'granted') solicitarGps({ maximumAge: 60000 });
        else setGps(status.state === 'denied' ? 'denied' : 'prompt');
      };
    } catch (_) {
      setGps('prompt');
      setGpsPermiso('prompt');
    }
  }, [solicitarGps]);

  // En celular el permiso suele requerir una accion del usuario; por eso se consulta el estado y se deja boton visible.
  useEffect(() => { consultarPermisoGps(); }, [consultarPermisoGps]);

  const capturarGps = () => solicitarGps({ timeout: 10000 });

  const registrarConEmpresa = async (tipo, empresa) => {
    setLoading(true); setMsg('');
    let gpsActual = gps && typeof gps === 'object' ? gps : null;
    if (!gpsActual && gps !== 'no') gpsActual = await solicitarGps({ timeout: 10000 });
    const body = { tipo, empresa: empresa || null };
    if (gpsActual) { body.lat = gpsActual.lat; body.lng = gpsActual.lng; }
    const r = await fetch(`${API}/api/tecnico/registro`, { method: 'POST', headers: jsonHdr(), body: JSON.stringify(body) });
    const d = await r.json();
    if (r.ok) { setMsg('Registrado'); setEmpresaSel(''); cargarDatos(); setSemanaKey(k => k + 1); } else setMsg(d.error || 'Error');
    setLoading(false);
  };

  const registrar = async (tipo) => registrarConEmpresa(tipo, empresaSel);

  const eventoHoy = (tipo) => (hoy?.eventos || []).some(ev => String(ev.tipo || '').toUpperCase() === tipo);
  const tieneEntrada = hoy?.entrada || eventoHoy('ENTRADA'), tieneSalida = hoy?.salida || eventoHoy('SALIDA');
  const tieneSalidaAlm = hoy?.salida_almuerzo || eventoHoy('ALMUERZO_SALIDA'), tieneRegresoAlm = hoy?.regreso_almuerzo || eventoHoy('ALMUERZO_REGRESO');
  const empresaActual = hoy?.ultima_empresa || hoy?.empresa_entrada || '';
  const empresasVisibles = empresas.filter(e => e.tecnico_visible);
  const enAlmuerzo = !!tieneSalidaAlm && !tieneRegresoAlm;
  const empresaSeleccionadaEsActual = empresaSel && empresaActual && empresaSel === empresaActual;
  const puedeEntrada = !tieneEntrada && !tieneSalida && !!empresaSel;
  const puedeSalidaAlmuerzo = !!tieneEntrada && !tieneSalidaAlm && !tieneSalida;
  const empresaRegresoAlmuerzo = empresaSel || empresaActual;
  const puedeRegresoAlmuerzo = !!tieneEntrada && !tieneSalida && !tieneRegresoAlm;
  const puedeOtroDesplazamiento = !!tieneEntrada && !tieneSalida && !enAlmuerzo && !!empresaSel && !empresaSeleccionadaEsActual;
  const puedeSalidaDia = !!tieneEntrada && !tieneSalida && !enAlmuerzo && !!(empresaActual || empresaSel);

  const diaSemana = ['Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado'][now.getDay()];
  const fechaStr  = `${diaSemana} ${now.getDate().toString().padStart(2,'0')}/${(now.getMonth()+1).toString().padStart(2,'0')}/${now.getFullYear()}`;
  const horaStr   = now.toTimeString().slice(0,8);

  return (
    <div style={s.wrap}>
      {/* Fecha, hora y red */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10, marginBottom: 16,
        background: '#ffffff', border: `1px solid ${C.border}`, borderRadius: 12, padding: '14px 20px' }}>
        <div>
          <div style={{ fontSize: 12, color: C.muted, marginBottom: 2 }}>{fechaStr}</div>
          <div style={{ fontSize: 28, fontWeight: 800, color: C.accent, fontVariantNumeric: 'tabular-nums', letterSpacing: 1 }}>{horaStr}</div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 6 }}>
          {/* GPS status: visible solo para admin */}
          {isAdmin && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
              {gpsLoading
                ? <span style={{ fontSize: 12, color: C.yellow }}>GPS: obteniendo...</span>
                : gps && typeof gps === 'object'
                  ? <span style={{ fontSize: 12, color: C.green }}>GPS: {gps.lat.toFixed(4)}, {gps.lng.toFixed(4)}</span>
                  : gps === 'denied'
                    ? <button onClick={capturarGps} style={{ ...s.btnSm('#1e3a50'), fontSize: 11 }}>GPS bloqueado - reintentar</button>
                    : <button onClick={capturarGps} style={{ ...s.btnSm('#1e3a50'), fontSize: 11 }}>Activar GPS</button>
              }
            </div>
          )}
          {/* Red */}
          {red && (
            <div style={{ fontSize: 11, color: red.tipo === 'wifi' ? C.green : C.yellow, display: 'flex', alignItems: 'center', gap: 5 }}>
              {red.tipo === 'wifi' ? '📶' : '📡'} {red.label}
            </div>
          )}
          {isAdmin && gpsPermiso === 'denied' && (
            <div style={{ fontSize: 11, color: C.yellow, textAlign: 'right', maxWidth: 280 }}>
              La ubicacion esta bloqueada en el navegador. Activa Permitir ubicacion en permisos del sitio y toca reintentar.
            </div>
          )}
        </div>
      </div>

      {(!isAdmin || usuarioEmpresasId) && (
        <MiSemanaCard
          usuarioId={isAdmin ? usuarioEmpresasId : null}
          nombre={isAdmin ? usuariosRegistro.find(u => String(u.id) === String(usuarioEmpresasId))?.nombre : null}
          refreshKey={semanaKey}
          now={now}
        />
      )}

      <div style={s.card}>
        <div style={s.secTitle}>Registro del día</div>


        {isAdmin && usuariosRegistro.length > 0 && (
          <div style={{ marginBottom: 14 }}>
            <label style={{ ...s.label, color: '#94a3b8' }}>Empresas habilitadas para</label>
            <select style={s.select} value={usuarioEmpresasId} onChange={e => setUsuarioEmpresasId(e.target.value)}>
              {usuariosRegistro.map(u => <option key={u.id} value={u.id}>{u.nombre}</option>)}
            </select>
          </div>
        )}

        <div style={{ marginBottom: 14 }}>
          <label style={{ ...s.label, color: '#94a3b8' }}>{!tieneEntrada ? 'Empresa donde inicias el dia' : enAlmuerzo ? 'Si regresas a la misma empresa deja este campo quieto; si llegas a otra empresa, seleccionala' : 'Selecciona empresa solo si vas a otro desplazamiento'}</label>
          <select style={s.select} value={empresaSel} onChange={e => setEmpresaSel(e.target.value)} disabled={!!tieneSalida}>
            <option value="">Seleccionar empresa...</option>
            {empresasVisibles.map(e => <option key={e.nombre} value={e.nombre}>{e.nombre}</option>)}
          </select>
          {empresaActual && <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 6 }}>{enAlmuerzo ? `Antes de almuerzo estaba en ${empresaActual}` : `Estado actual: en ${empresaActual}`}</div>}
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: 12, marginBottom: 16 }}>
          <button onClick={() => registrar('entrada')} disabled={loading || !puedeEntrada}
            style={{ ...s.btn(tieneEntrada ? 'rgba(16,185,129,0.15)' : C.green), border: tieneEntrada ? '1px solid rgba(16,185,129,0.4)' : 'none', flexDirection: 'column', alignItems: 'center', padding: '14px 8px', display: 'flex' }}>
            <span style={{ fontSize: 15, color: tieneEntrada ? '#10b981' : '#fff' }}>{tieneEntrada ? '\u2713 ' : ''}{'\u25B6'} Entrada</span>
            {tieneEntrada && hoy?.entrada && <span style={{ fontSize: 12, fontWeight: 700, color: '#10b981', marginTop: 2 }}>{fmtTime(hoy.entrada)}</span>}
            {(hoy?.empresa_entrada || (!tieneEntrada && empresaSel)) && <span style={{ fontSize: 10, color: tieneEntrada ? '#10b981' : '#fff', opacity: .85, marginTop: 1 }}>{tieneEntrada ? 'Ingreso en' : 'Iniciando en'}: {hoy?.empresa_entrada || empresaSel}</span>}
          </button>

          <button onClick={() => registrarConEmpresa('salida_almuerzo', empresaActual || empresaSel)} disabled={loading || !puedeSalidaAlmuerzo}
            style={{ ...s.btn(tieneSalidaAlm ? 'rgba(16,185,129,0.15)' : C.yellow), border: tieneSalidaAlm ? '1px solid rgba(16,185,129,0.4)' : 'none', flexDirection: 'column', alignItems: 'center', padding: '14px 8px', display: 'flex' }}>
            <span style={{ fontSize: 15, color: tieneSalidaAlm ? '#10b981' : '#fff' }}>{tieneSalidaAlm ? '\u2713 ' : ''}{'\uD83C\uDF7D'} Salida almuerzo</span>
            {tieneSalidaAlm && hoy?.salida_almuerzo && <span style={{ fontSize: 12, fontWeight: 700, color: '#10b981', marginTop: 2 }}>{fmtTime(hoy.salida_almuerzo)}</span>}
          </button>

          <button onClick={() => registrarConEmpresa('regreso_almuerzo', empresaRegresoAlmuerzo)} disabled={loading || !!tieneRegresoAlm || !!tieneSalida}
            style={{ ...s.btn(tieneRegresoAlm ? 'rgba(16,185,129,0.15)' : C.accent), border: tieneRegresoAlm ? '1px solid rgba(16,185,129,0.4)' : 'none', flexDirection: 'column', alignItems: 'center', padding: '14px 8px', display: 'flex' }}>
            <span style={{ fontSize: 15, color: tieneRegresoAlm ? '#10b981' : '#fff' }}>{tieneRegresoAlm ? '\u2713 ' : ''}{'\u21A9'} Regreso almuerzo</span>
            {tieneRegresoAlm && hoy?.regreso_almuerzo && <span style={{ fontSize: 12, fontWeight: 700, color: '#10b981', marginTop: 2 }}>{fmtTime(hoy.regreso_almuerzo)}</span>}
            {!tieneRegresoAlm && <span style={{ fontSize: 10, color: '#fff', opacity: .8, marginTop: 1 }}>{empresaRegresoAlmuerzo ? `${empresaSel ? 'Llega a' : 'Regresa a'}: ${empresaRegresoAlmuerzo}` : 'Regresa a la ultima empresa registrada'}</span>}
          </button>

          <button onClick={() => registrarConEmpresa('salida', empresaActual || empresaSel)} disabled={loading || !puedeSalidaDia}
            style={{ ...s.btn(tieneSalida ? 'rgba(16,185,129,0.15)' : C.red), border: tieneSalida ? '1px solid rgba(16,185,129,0.4)' : 'none', flexDirection: 'column', alignItems: 'center', padding: '14px 8px', display: 'flex' }}>
            <span style={{ fontSize: 15, color: tieneSalida ? '#10b981' : '#fff' }}>{tieneSalida ? '\u2713 ' : ''}{'\u25A0'} Salida del dia</span>
            {tieneSalida && hoy?.salida && <span style={{ fontSize: 12, fontWeight: 700, color: '#10b981', marginTop: 2 }}>{fmtTime(hoy.salida)}</span>}
            {(empresaActual || empresaSel) && <span style={{ fontSize: 10, color: tieneSalida ? '#10b981' : '#fff', opacity: .85, marginTop: 1 }}>Salida desde: {empresaActual || empresaSel}</span>}
          </button>
        </div>

        <div style={{ borderTop: '1px solid rgba(255,255,255,.12)', paddingTop: 16 }}>
          <div style={{ ...s.secTitle, color: '#94a3b8' }}>Otro desplazamiento</div>
          <div style={{ fontSize: 12, color: '#94a3b8', marginBottom: 10 }}>Usalo solo si durante el dia vas a otra empresa. Selecciona la nueva empresa y registra el movimiento.</div>
          <div style={s.row}>
            <div style={{ flex: 2, minWidth: 160 }}>
              <label style={{ ...s.label, color: '#94a3b8' }}>Nueva empresa</label>
              <select style={s.select} value={empresaSel} onChange={e => setEmpresaSel(e.target.value)} disabled={!tieneEntrada || !!tieneSalida || enAlmuerzo}>
                <option value="">Seleccionar...</option>
                {empresasVisibles.map(e => <option key={e.nombre} value={e.nombre}>{e.nombre}</option>)}
              </select>
            </div>
            <div style={{ display: 'flex', alignItems: 'flex-end', gap: 8 }}>
              <button style={s.btn(C.accent)} onClick={() => registrar('llegada_empresa')} disabled={loading || !puedeOtroDesplazamiento}>Otro desplazamiento</button>
            </div>
          </div>
        </div>

        {msg && <div style={{ marginTop: 14, padding: '8px 12px', borderRadius: 8, background: msg.includes('Error') ? C.red+'22' : C.green+'22', color: msg.includes('Error') ? C.red : C.green, fontSize: 13 }}>{msg}</div>}
      </div>

      {/* Actividad de hoy — solo hoy, solo lectura */}
      {hoy?.eventos?.length > 0 && (
        <div style={s.card}>
          <div style={s.secTitle}>Actividad de hoy</div>
          {hoy.eventos.map((ev, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '8px 12px', background: '#f7fafd', border: `1px solid ${C.border}`, borderRadius: 8, marginBottom: 6 }}>
              <span style={{ fontSize: 18 }}>{TIPO_ICON[ev.tipo] || '•'}</span>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 13, fontWeight: 600 }}>{TIPO_LABEL[ev.tipo] || ev.tipo}{ev.empresa ? ` — ${ev.empresa}` : ''}</div>
                {isAdmin && ev.lat && ev.lng && <div style={{ fontSize: 11, color: C.muted }}>GPS: {parseFloat(ev.lat).toFixed(4)}, {parseFloat(ev.lng).toFixed(4)}</div>}
              </div>
              <span style={{ fontSize: 13, color: C.accent, fontWeight: 700 }}>{fmtTime(ev.hora)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ─── Admin: panel completo registros técnico ─────────────────────────────────

// Mapeo DB → display (los tipos en DB están en mayúscula)
const TIPO_DB_LABEL = { ENTRADA:'Entrada', SALIDA:'Salida del dia', ALMUERZO_SALIDA:'Salida almuerzo', ALMUERZO_REGRESO:'Regreso almuerzo', EMPRESA_ENTRADA:'Desplazamiento', EMPRESA_SALIDA:'Salida empresa' };
const TIPO_DB_ICON  = { ENTRADA:'▶', SALIDA:'■', ALMUERZO_SALIDA:'🍽', ALMUERZO_REGRESO:'↩', EMPRESA_ENTRADA:'🏢', EMPRESA_SALIDA:'🚗' };

function hFmt(h) { if (h === null || h === undefined) return '—'; return parseFloat(h).toFixed(1) + 'h'; }

function AdminRegistros({ empresas }) {
  const [subTab,    setSubTab]    = useState('dia');
  const [fecha,     setFecha]     = useState(new Date().toISOString().slice(0,10));
  const [registros, setRegistros] = useState([]);
  const [tecnicos,  setTecnicos]  = useState([]);
  const [editando,  setEditando]  = useState(null);
  const [showAdd,   setShowAdd]   = useState(false);
  const [addForm,   setAddForm]   = useState({ usuario_id: '', tipo: 'entrada', empresa: '', hora: '' });
  const [editForm,  setEditForm]  = useState({ usuario_id: '', tipo: '', empresa: '', hora: '' });

  // Consolidado
  const mesHoy = new Date();
  const [consDesde, setConsDesde] = useState(
    mesHoy.getFullYear() + '-' + String(mesHoy.getMonth() + 1).padStart(2,'0') + '-01');
  const [consHasta, setConsHasta] = useState(new Date().toISOString().slice(0,10));
  const [consData,  setConsData]  = useState([]);
  const [consLoad,  setConsLoad]  = useState(false);
  const [festivosDates, setFestivosDates] = useState(new Set());
  const [festivosList,  setFestivosList]  = useState([]);
  const [festivoForm,   setFestivoForm]   = useState({ fecha: '', descripcion: '' });
  const [festivoMsg,    setFestivoMsg]    = useState('');

  const cargar = useCallback(() => {
    fetch(`${API}/api/tecnico/admin/registros?fecha=${fecha}`, { headers: hdr() })
      .then(r => r.json()).then(d => setRegistros(Array.isArray(d) ? d : [])).catch(() => {});
  }, [fecha]);

  useEffect(() => { cargar(); }, [cargar]);
  useEffect(() => {
    fetch(`${API}/api/usuarios/tecnicos`, { headers: hdr() })
      .then(r => r.json()).then(d => setTecnicos(Array.isArray(d) ? d : [])).catch(() => {});
  }, []);

  const cargarConsolidado = useCallback(() => {
    setConsLoad(true);
    fetch(`${API}/api/tecnico/admin/consolidado?desde=${consDesde}&hasta=${consHasta}`, { headers: hdr() })
      .then(r => r.json()).then(d => { setConsData(Array.isArray(d) ? d : []); setConsLoad(false); }).catch(() => setConsLoad(false));
  }, [consDesde, consHasta]);

  useEffect(() => { if (subTab === 'consolidado' || subTab === 'stats') cargarConsolidado(); }, [subTab, cargarConsolidado]);

  const cargarFestivos = useCallback(() => {
    const anio = new Date().getFullYear();
    fetch(`${API}/api/tecnico/festivos?desde=${anio}-01-01&hasta=${anio}-12-31`, { headers: hdr() })
      .then(r => r.json())
      .then(d => {
        const list = Array.isArray(d) ? d : [];
        setFestivosList(list);
        setFestivosDates(new Set(list.map(f => String(f.fecha).slice(0,10))));
      }).catch(() => {});
  }, []);
  useEffect(() => { cargarFestivos(); }, [cargarFestivos]);

  const agregarFestivo = async () => {
    if (!festivoForm.fecha) return;
    setFestivoMsg('');
    const r = await fetch(`${API}/api/tecnico/festivos`, { method: 'POST', headers: jsonHdr(), body: JSON.stringify(festivoForm) });
    if (r.ok) { setFestivoForm({ fecha: '', descripcion: '' }); cargarFestivos(); setFestivoMsg('Festivo guardado'); }
    else { const d = await r.json(); setFestivoMsg(d.error || 'Error'); }
  };
  const eliminarFestivo = async (fecha) => {
    await fetch(`${API}/api/tecnico/festivos/${encodeURIComponent(fecha)}`, { method: 'DELETE', headers: hdr() });
    cargarFestivos();
  };

  const agregar = async () => {
    if (!addForm.usuario_id || !addForm.tipo || !addForm.hora) return;
    const r = await fetch(`${API}/api/tecnico/admin/registros`, {
      method: 'POST', headers: jsonHdr(),
      body: JSON.stringify(addForm),
    });
    if (r.ok) { setShowAdd(false); setAddForm({ usuario_id: '', tipo: 'entrada', empresa: '', hora: '' }); cargar(); }
    else { const d = await r.json(); alert(d.error || 'Error al agregar'); }
  };

  const [editMsg, setEditMsg] = useState('');
  const guardarEdicion = async () => {
    if (!editando) return;
    setEditMsg('');
    const r = await fetch(`${API}/api/tecnico/admin/registros/${editando}`, {
      method: 'PUT', headers: jsonHdr(),
      body: JSON.stringify(editForm),
    });
    if (r.ok) { setEditando(null); setEditMsg(''); cargar(); }
    else { const d = await r.json(); setEditMsg(d.error || 'Error al guardar'); }
  };

  const eliminar = async (id) => {
    if (!window.confirm('¿Eliminar este registro?')) return;
    await fetch(`${API}/api/tecnico/admin/registros/${id}`, { method: 'DELETE', headers: hdr() });
    cargar();
  };

  const abrirUbicacion = (r) => {
    if (!r.lat || !r.lng) return;
    window.open(`https://www.google.com/maps?q=${r.lat},${r.lng}`, '_blank', 'noopener,noreferrer');
  };

  const iniciarEdit = (r) => {
    setEditando(r.id);
    // r.tipo en DB es mayúscula, convertir a minúscula para el select del form
    const tipoForm = r.tipo.toLowerCase().replace('almuerzo_salida','salida_almuerzo').replace('almuerzo_regreso','regreso_almuerzo').replace('empresa_entrada','llegada_empresa').replace('empresa_salida','salida_empresa');
    // r.fecha puede ser Date object (mysql2) o string — combinar con hora TIME
    const fechaStr = safeDate(r.fecha);
    const fechaHora = fechaStr ? `${fechaStr}T${r.hora || '00:00'}` : '';
    setEditForm({ usuario_id: r.usuario_id || '', tipo: tipoForm, empresa: r.empresa || '', hora: fechaHora.slice(0,16) });
  };

  // Stats calculadas del consolidado
  const rowDate = (r) => safeDate(r.fecha);
  const pad = (n) => String(n).padStart(2, '0');
  const keyOf = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  const statsRef = consHasta ? new Date(`${consHasta}T12:00:00`) : new Date();
  const y = statsRef.getFullYear();
  const m = statsRef.getMonth();
  const monday = new Date(y, m, statsRef.getDate() - ((statsRef.getDay() + 6) % 7));
  const friday = new Date(monday); friday.setDate(monday.getDate() + 4);
  const weekStart = keyOf(monday);
  const weekEnd = keyOf(friday);
  const monthStart = `${y}-${pad(m + 1)}-01`;
  const monthEnd = keyOf(statsRef);
  const quinStart = `${y}-${pad(m + 1)}-${statsRef.getDate() <= 15 ? '01' : '16'}`;
  const quinEnd = keyOf(statsRef);
  const hoursOf = (rows) => rows.reduce((sum, r) => sum + (parseFloat(r.horas_laborales ?? r.horas_netas) || 0), 0);
  const visitsOf = (rows) => rows.reduce((sum, r) => sum + (parseInt(r.num_visitas) || 0), 0);
  const inRange = (r, a, b) => { const k = rowDate(r); return k && k >= a && k <= b; };
  const dataSemana = consData.filter(r => inRange(r, weekStart, weekEnd));
  const dataMes = consData.filter(r => inRange(r, monthStart, monthEnd));
  const dataQuincena = consData.filter(r => inRange(r, quinStart, quinEnd));
  const totalHoras   = hoursOf(consData);
  const horasSemana  = hoursOf(dataSemana);
  const horasMes     = hoursOf(dataMes);
  const horasQuincena = hoursOf(dataQuincena);
  const diasCon      = consData.filter(r => (parseFloat(r.horas_laborales ?? r.horas_netas) || 0) > 0).length;
  const promHoras    = diasCon > 0 ? totalHoras / diasCon : 0;
  const totalVisitas = visitsOf(consData);
  const festivosSemana = [...festivosDates].filter(d => d >= weekStart && d <= weekEnd);
  const festivosEnSemana = festivosSemana.length;
  const metaSemanal  = metaSemanaHoras(festivosSemana);
  const almuerzoData = dataSemana.filter(r => (r.almuerzo_horas || 0) > 0);
  const almuerzoPromedio = almuerzoData.length > 0 ? almuerzoData.reduce((s,r) => s + (parseFloat(r.almuerzo_horas)||0), 0) / almuerzoData.length : 0;
  const horasFaltan  = Math.max(0, metaSemanal - horasSemana);
  const pctMeta42    = Math.min(Math.round((horasSemana / metaSemanal) * 100), 100);
  const metaColor    = horasSemana >= metaSemanal ? C.green : horasSemana >= metaSemanal*0.9 ? C.red : horasSemana >= metaSemanal*0.75 ? C.yellow : C.accent;
  const empCount     = {};
  consData.forEach(r => { (r.empresas || '').split(', ').filter(Boolean).forEach(e => { empCount[e] = (empCount[e] || 0) + 1; }); });
  const topEmpresas  = Object.entries(empCount).sort((a,b) => b[1]-a[1]).slice(0, 5);

  const subBtnStyle = (k) => ({ padding: '8px 14px', borderRadius: 8, border: 'none', cursor: 'pointer', fontFamily: 'inherit', fontSize: 12, fontWeight: 700,
    background: subTab === k ? '#0d3451' : '#e8eef5', color: subTab === k ? '#fff' : '#52677d' });
  const gpsPill = (r) => r.lat && r.lng
    ? { text: 'GPS registrado', bg: '#d1fae5', color: '#047857', border: '#a7f3d0' }
    : { text: 'Sin GPS', bg: '#fff7ed', color: '#b45309', border: '#fed7aa' };

  return (
    <div style={{ marginTop: 8, background: '#ffffff', borderRadius: 12, padding: 20, border: `1px solid ${C.border}` }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 8 }}>
        <div style={s.secTitle}>Panel admin — Técnico</div>
        <div style={{ display: 'flex', gap: 6 }}>
          <button style={subBtnStyle('dia')}         onClick={() => setSubTab('dia')}>Por día</button>
          <button style={subBtnStyle('consolidado')} onClick={() => setSubTab('consolidado')}>Consolidado</button>
          <button style={subBtnStyle('stats')}       onClick={() => setSubTab('stats')}>Estadísticas</button>
        </div>
      </div>

      {/* ── Sub-tab: Por día ── */}
      {subTab === 'dia' && (
        <>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 14, flexWrap: 'wrap' }}>
            <input type="date" value={fecha} onChange={e => setFecha(e.target.value)}
              style={{ ...s.input, width: 'auto', fontSize: 12 }} />
            <button style={s.btnSm(C.accent)} onClick={() => setShowAdd(v => !v)}>+ Agregar</button>
          </div>

          {showAdd && (
            <div style={{ background: '#f7fafd', border: `1px solid ${C.border}`, borderRadius: 10, padding: 16, marginBottom: 16, display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: 10 }}>
              <div>
                <label style={s.label}>Técnico</label>
                <select style={s.select} value={addForm.usuario_id} onChange={e => setAddForm(f => ({ ...f, usuario_id: e.target.value }))}>
                  <option value="">Seleccionar...</option>
                  {tecnicos.map(t => <option key={t.id} value={t.id}>{t.nombre}</option>)}
                </select>
              </div>
              <div>
                <label style={s.label}>Tipo</label>
                <select style={s.select} value={addForm.tipo} onChange={e => setAddForm(f => ({ ...f, tipo: e.target.value }))}>
                  {TIPOS.map(t => <option key={t} value={t}>{TIPO_LABEL[t]}</option>)}
                </select>
              </div>
              <div>
                <label style={s.label}>Empresa (opcional)</label>
                <select style={s.select} value={addForm.empresa} onChange={e => setAddForm(f => ({ ...f, empresa: e.target.value }))}>
                  <option value="">Ninguna</option>
                  {empresas.map(e => <option key={e.nombre} value={e.nombre}>{e.nombre}</option>)}
                </select>
              </div>
              <div>
                <label style={s.label}>Hora</label>
                <input type="datetime-local" style={s.input} value={addForm.hora} onChange={e => setAddForm(f => ({ ...f, hora: e.target.value }))} />
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-end', gap: 8, gridColumn: '1/-1' }}>
                <button style={s.btnSm(C.accent)} onClick={agregar}>Guardar</button>
                <button style={s.btnSm('#1e3a50')} onClick={() => setShowAdd(false)}>Cancelar</button>
              </div>
            </div>
          )}

          {registros.length === 0
            ? <div style={{ color: C.muted, textAlign: 'center', padding: 24, fontSize: 13 }}>Sin registros para esta fecha</div>
            : registros.map(r => {
              const gpsInfo = gpsPill(r);
              return (
              <div key={r.id} style={{ background: '#f7fafd', border: `1px solid ${C.border}`, borderRadius: 10, padding: '12px 14px', marginBottom: 8 }}>
                {editando === r.id ? (
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: 8 }}>
                    <div>
                      <label style={s.label}>Tecnico</label>
                      <select style={s.select} value={editForm.usuario_id} onChange={e => setEditForm(f => ({ ...f, usuario_id: e.target.value }))}>
                        {tecnicos.map(t => <option key={t.id} value={t.id}>{t.nombre}</option>)}
                      </select>
                    </div>
                    <div>
                      <label style={s.label}>Tipo</label>
                      <select style={s.select} value={editForm.tipo} onChange={e => setEditForm(f => ({ ...f, tipo: e.target.value }))}>
                        {TIPOS.map(t => <option key={t} value={t}>{TIPO_LABEL[t]}</option>)}
                      </select>
                    </div>
                    <div>
                      <label style={s.label}>Empresa</label>
                      <select style={s.select} value={editForm.empresa} onChange={e => setEditForm(f => ({ ...f, empresa: e.target.value }))}>
                        <option value="">Ninguna</option>
                        {empresas.map(e => <option key={e.nombre} value={e.nombre}>{e.nombre}</option>)}
                      </select>
                    </div>
                    <div>
                      <label style={s.label}>Hora</label>
                      <input type="datetime-local" style={s.input} value={editForm.hora} onChange={e => setEditForm(f => ({ ...f, hora: e.target.value }))} />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'flex-end', gap: 8, flexWrap: 'wrap' }}>
                      <button style={s.btnSm(C.green)} onClick={guardarEdicion}>Guardar</button>
                      <button style={s.btnSm('#1e3a50')} onClick={() => { setEditando(null); setEditMsg(''); }}>Cancelar</button>
                      {editMsg && <span style={{ fontSize: 12, color: C.red }}>{editMsg}</span>}
                    </div>
                  </div>
                ) : (
                  <div style={{ display: 'grid', gridTemplateColumns: 'auto minmax(180px,1fr) auto auto', alignItems: 'center', gap: 12 }}>
                    <span style={{ width: 36, height: 36, borderRadius: 8, background: '#e8eef5', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>{TIPO_DB_ICON[r.tipo] || '-'}</span>
                    <div style={{ minWidth: 0 }}>
                      <div style={{ fontSize: 14, fontWeight: 800, color: '#0a2235' }}>
                        {TIPO_DB_LABEL[r.tipo] || r.tipo}{r.empresa ? <span style={{ color: C.accent }}> - {r.empresa}</span> : ''}
                      </div>
                      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center', marginTop: 5 }}>
                        <span style={{ fontSize: 11, color: C.muted }}>{r.tecnico_nombre}</span>
                        <span style={{ fontSize: 11, fontWeight: 700, padding: '3px 8px', borderRadius: 999, background: gpsInfo.bg, color: gpsInfo.color, border: `1px solid ${gpsInfo.border}` }}>{gpsInfo.text}</span>
                      </div>
                    </div>
                    <div style={{ textAlign: 'right', flexShrink: 0 }}>
                      <div style={{ fontSize: 11, color: C.muted }}>{safeDate(r.fecha)}</div>
                      <div style={{ fontSize: 18, fontWeight: 800, color: C.accent }}>{fmtTime(r.hora)}</div>
                    </div>
                    <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                      {r.lat && r.lng && <button style={s.btnSm(C.accent)} onClick={() => abrirUbicacion(r)}>Ver mapa</button>}
                      <button style={s.btnSm('#143a57')} onClick={() => iniciarEdit(r)}>Editar</button>
                      <button style={s.btnSm(C.red)} onClick={() => eliminar(r.id)}>Quitar</button>
                    </div>
                  </div>
                )}
              </div>
              );
            })
          }
        </>
      )}

      {/* ── Sub-tab: Consolidado ── */}
      {subTab === 'consolidado' && (
        <>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 14, flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <label style={s.label}>Desde</label>
              <input type="date" value={consDesde} onChange={e => setConsDesde(e.target.value)} style={{ ...s.input, width: 'auto', fontSize: 12 }} />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <label style={s.label}>Hasta</label>
              <input type="date" value={consHasta} onChange={e => setConsHasta(e.target.value)} style={{ ...s.input, width: 'auto', fontSize: 12 }} />
            </div>
            <button style={s.btnSm(C.accent)} onClick={cargarConsolidado}>Cargar</button>
          </div>
          {consLoad && <div style={{ color: C.muted, textAlign: 'center', padding: 16, fontSize: 13 }}>Cargando...</div>}
          {!consLoad && consData.length === 0 && <div style={{ color: C.muted, textAlign: 'center', padding: 16, fontSize: 13 }}>Sin datos para el período</div>}
          {!consLoad && consData.length > 0 && (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                <thead>
                  <tr style={{ borderBottom: `1px solid ${C.border}` }}>
                    {['Fecha','Técnico','Entrada','Almuerzo','Regreso','Salida','Tiempo almuerzo','Horas laborales','Visitas','Empresas'].map(h => (
                      <th key={h} style={{ padding: '8px 10px', textAlign: 'left', color: C.muted, fontWeight: 600, fontSize: 11, textTransform: 'uppercase', letterSpacing: 0.5 }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {consData.map((r, i) => (
                    <tr key={i} style={{ borderBottom: `1px solid ${C.border}22` }}>
                      <td style={{ padding: '8px 10px', color: C.muted }}>{safeDate(r.fecha)}</td>
                      <td style={{ padding: '8px 10px', fontWeight: 600 }}>{r.tecnico}</td>
                      <td style={{ padding: '8px 10px', color: C.green }}>{fmtTime(r.entrada)}</td>
                      <td style={{ padding: '8px 10px', color: C.yellow }}>{fmtTime(r.salida_almuerzo)}</td>
                      <td style={{ padding: '8px 10px', color: C.yellow }}>{fmtTime(r.regreso_almuerzo)}</td>
                      <td style={{ padding: '8px 10px', color: C.red }}>{fmtTime(r.salida)}</td>
                      <td style={{ padding: '8px 10px', color: r.almuerzo_horas > 0 ? C.yellow : C.muted }}>{hFmt(r.almuerzo_horas || 0)}</td>
                      <td style={{ padding: '8px 10px', fontWeight: 700, color: r.horas_laborales >= 8 ? C.green : C.accent }}>{hFmt(r.horas_laborales ?? r.horas_netas)}</td>
                      <td style={{ padding: '8px 10px', color: C.yellow }}>{r.num_empresas || 0}</td>
                      <td style={{ padding: '8px 10px', color: C.muted, fontSize: 11 }}>{r.empresas || '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}

      {/* ── Sub-tab: Estadísticas ── */}
      {subTab === 'stats' && (
        <>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 16, flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <label style={s.label}>Desde</label>
              <input type="date" value={consDesde} onChange={e => setConsDesde(e.target.value)} style={{ ...s.input, width: 'auto', fontSize: 12 }} />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <label style={s.label}>Hasta</label>
              <input type="date" value={consHasta} onChange={e => setConsHasta(e.target.value)} style={{ ...s.input, width: 'auto', fontSize: 12 }} />
            </div>
            <button style={s.btnSm(C.accent)} onClick={cargarConsolidado}>Cargar</button>
          </div>
          {consLoad && <div style={{ color: C.muted, textAlign: 'center', padding: 16, fontSize: 13 }}>Cargando...</div>}
          {!consLoad && (
            <>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: 12, marginBottom: 16 }}>
                {[
                  { label: 'Horas periodo',   value: totalHoras.toFixed(1) + 'h',    color: C.accent },
                  { label: 'Horas semana',    value: horasSemana.toFixed(1) + 'h',   color: metaColor },
                  { label: 'Horas quincena',  value: horasQuincena.toFixed(1) + 'h', color: C.green },
                  { label: 'Horas mes',       value: horasMes.toFixed(1) + 'h',      color: C.accent },
                  { label: 'Prom. horas dia', value: promHoras.toFixed(1) + 'h',     color: C.yellow },
                  { label: 'Empresas visitadas', value: totalVisitas,                color: C.text },
                ].map((k, i) => (
                  <div key={i} style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 10, padding: '14px 16px' }}>
                    <div style={{ fontSize: 10, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1, color: C.muted, marginBottom: 6 }}>{k.label}</div>
                    <div style={{ fontSize: 24, fontWeight: 700, color: k.color }}>{k.value}</div>
                  </div>
                ))}
              </div>
              {/* Meta semanal */}
              <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 10, padding: '16px 18px', marginBottom: 16 }}>
                {/* Encabezado con botones de exportar */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14, flexWrap: 'wrap', gap: 8 }}>
                  <div style={{ ...s.secTitle, margin: 0 }}>Meta semanal — lunes a viernes</div>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <button onClick={() => generarReporteSemanal({ dataSemana, weekStart, weekEnd, metaSemanal, horasSemana, festivosDates, almuerzoPromedio, tecnicoNombre: dataSemana[0]?.tecnico || '' })}
                      style={s.btnSm('#08293f')}>PDF</button>
                    <button onClick={() => { const txt = textoReporteSemanal({ dataSemana, weekStart, weekEnd, metaSemanal, horasSemana, festivosDates, almuerzoPromedio, tecnicoNombre: dataSemana[0]?.tecnico || '' }); navigator.clipboard?.writeText(txt).then(() => alert('Copiado. Pega en WhatsApp.')); }}
                      style={s.btnSm(C.green)}>WhatsApp</button>
                  </div>
                </div>

                {/* Mini-calendario semanal — toggle festivos */}
                {(() => {
                  const DIAS_CORTO = ['L','M','X','J','V'];
                  const DIAS_LABEL = ['Lun','Mar','Mie','Jue','Vie'];
                  const dias = [];
                  const d = new Date(`${weekStart}T12:00:00`);
                  for (let i = 0; i < 5; i++) {
                    const k = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
                    dias.push({ k, short: DIAS_CORTO[i], label: DIAS_LABEL[i], n: d.getDate(), festivo: festivosDates.has(k) });
                    d.setDate(d.getDate()+1);
                  }
                  const toggleFestivo = async (k, esFestivo) => {
                    if (esFestivo) {
                      await fetch(`${API}/api/tecnico/festivos/${encodeURIComponent(k)}`, { method: 'DELETE', headers: hdr() });
                    } else {
                      await fetch(`${API}/api/tecnico/festivos`, { method: 'POST', headers: jsonHdr(), body: JSON.stringify({ fecha: k, descripcion: 'Festivo' }) });
                    }
                    cargarFestivos();
                  };
                  return (
                    <div style={{ marginBottom: 14 }}>
                      <div style={{ fontSize: 11, color: C.muted, marginBottom: 6, fontWeight: 600 }}>
                        Dias festivos esta semana — clic para marcar/desmarcar
                      </div>
                      <div style={{ display: 'flex', gap: 6 }}>
                        {dias.map(({ k, label, n, festivo }) => (
                          <button key={k} onClick={() => toggleFestivo(k, festivo)} title={`${label} ${n} — ${festivo ? 'Festivo (clic para quitar)' : 'Laboral (clic para marcar festivo)'}`}
                            style={{ flex: 1, padding: '8px 4px', borderRadius: 8, border: `2px solid ${festivo ? C.yellow : C.border}`,
                              background: festivo ? 'rgba(245,158,11,0.12)' : '#f7fafc', cursor: 'pointer',
                              color: festivo ? '#b45309' : C.muted, fontWeight: festivo ? 800 : 600, fontSize: 12,
                              transition: 'all 0.15s', textAlign: 'center' }}>
                            <div style={{ fontSize: 10, marginBottom: 2 }}>{label}</div>
                            <div style={{ fontSize: 14, fontWeight: 800 }}>{n}</div>
                            {festivo && <div style={{ fontSize: 9, marginTop: 2, color: '#b45309' }}>Festivo</div>}
                          </button>
                        ))}
                      </div>
                      {festivosEnSemana > 0 && (
                        <div style={{ marginTop: 8, fontSize: 12, color: C.yellow, fontWeight: 600 }}>
                          {festivosEnSemana} festivo{festivosEnSemana > 1 ? 's' : ''} — meta ajustada a {durFmt(metaSemanal * 60)}
                        </div>
                      )}
                    </div>
                  );
                })()}

                {/* Barra de progreso */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: 8, gap: 12, flexWrap: 'wrap' }}>
                  <div style={{ fontSize: 30, fontWeight: 700, color: metaColor }}>{horasSemana.toFixed(1)}h</div>
                  <div style={{ fontSize: 13, color: C.muted }}>{weekStart} a {weekEnd} · meta {durFmt(metaSemanal * 60)} · {pctMeta42}%</div>
                </div>
                <div style={{ height: 14, background: '#1e3a50', borderRadius: 999, overflow: 'hidden', marginBottom: 10 }}>
                  <div style={{ width: pctMeta42 + '%', height: '100%', background: metaColor, borderRadius: 999, transition: 'width 0.4s' }} />
                </div>
                {horasSemana >= metaSemanal
                  ? <div style={{ fontSize: 13, fontWeight: 700, color: C.green }}>Meta semanal cumplida.</div>
                  : horasSemana >= metaSemanal * 0.9
                    ? <div style={{ fontSize: 13, fontWeight: 700, color: C.red }}>Alerta: muy cerca. Faltan {horasFaltan.toFixed(1)}h.</div>
                    : horasSemana >= metaSemanal * 0.75
                      ? <div style={{ fontSize: 13, fontWeight: 700, color: C.yellow }}>Acercandose. Faltan {horasFaltan.toFixed(1)}h.</div>
                      : <div style={{ fontSize: 13, color: C.muted }}>Faltan <span style={{ fontWeight: 700, color: C.yellow }}>{horasFaltan.toFixed(1)}h</span> para completar.</div>
                }
              </div>
              {topEmpresas.length > 0 && (
                <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 10, padding: '16px 18px' }}>
                  <div style={{ ...s.secTitle, marginBottom: 12 }}>Empresas más visitadas</div>
                  {topEmpresas.map(([emp, cnt], i) => {
                    const max = topEmpresas[0][1];
                    return (
                      <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
                        <span style={{ fontSize: 12, color: C.text, minWidth: 140 }}>{emp}</span>
                        <div style={{ flex: 1, height: 6, background: '#1e3a50', borderRadius: 3, overflow: 'hidden' }}>
                          <div style={{ width: `${(cnt / max) * 100}%`, height: '100%', background: C.accent, borderRadius: 3 }} />
                        </div>
                        <span style={{ fontSize: 12, fontWeight: 700, color: C.accent, minWidth: 24, textAlign: 'right' }}>{cnt}</span>
                      </div>
                    );
                  })}
                </div>
              )}
              {consData.length === 0 && <div style={{ color: C.muted, textAlign: 'center', padding: 16, fontSize: 13 }}>Sin datos para el período</div>}
            </>
          )}

        </>
      )}
    </div>
  );
}

// ─── Tab Empresas ─────────────────────────────────────────────────────────────

// embedded: se muestra dentro de la ficha del cliente (pestana Tecnico), sin encabezado propio.
export function EmpresaDetalle({ empresa, onBack, isAdmin, canDeleteInventory, embedded = false }) {
  const viewportWidth = useViewportWidth();
  const isPhone = viewportWidth < 640;
  const isTablet = viewportWidth >= 640 && viewportWidth < 980;
  const emptyForm = { tipo: '', valor: '', clave: '' };
  const [accesos, setAccesos] = useState([]);
  const [inventarioTotal, setInventarioTotal] = useState(0);
  const [notificacionesExpandido, setNotificacionesExpandido] = useState(false);
  // Secciones de la vista de empresa: arrancan compactadas al entrar
  const [validacionesAbiertas, setValidacionesAbiertas] = useState(false);
  const [registroAbierto, setRegistroAbierto] = useState(false);
  const [mapaAbierto, setMapaAbierto] = useState(false);
  const [historialBusqueda, setHistorialBusqueda] = useState('');
  const [historialTipo, setHistorialTipo] = useState('todos');
  const [validaciones, setValidaciones] = useState([]);
  const [registrosVal, setRegistrosVal] = useState([]);
  const [actividadesEmpresa, setActividadesEmpresa] = useState([]);
  const [actividadForm, setActividadForm] = useState({ tipo: 'Revision', estado: 'Resuelto', actividades: '', pendientes: '' });
  const [guardandoActividad, setGuardandoActividad] = useState(false);
  const [empresaConfig, setEmpresaConfig] = useState({ validaciones_activas: 1 });
  const [validacionesExpanded, setValidacionesExpanded] = useState(false);
  const [seccionesAcceso, setSeccionesAcceso] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [form, setForm] = useState(emptyForm);
  const [editando, setEditando] = useState(null);
  const [mostrarClave, setMostrarClave] = useState({});
  const [mostrarFormClave, setMostrarFormClave] = useState(false);
  const [msg, setMsg] = useState('');
  const [validando, setValidando] = useState(null);
  const [valForm, setValForm] = useState({ estado: 'Correcto', observacion: '' });
  const [editVal, setEditVal] = useState(null);
  const [valAdminForm, setValAdminForm] = useState({ nombre: '', descripcion: '', frecuencia: 'Semanal', orden: 0 });
  const [seccionActiva, setSeccionActiva] = useState(null);
  const [editSeccionTitulo, setEditSeccionTitulo] = useState(false);
  const [seccionTituloForm, setSeccionTituloForm] = useState('');
  const [nuevaSeccionForm, setNuevaSeccionForm] = useState('');
  const [mostrarNuevaSeccion, setMostrarNuevaSeccion] = useState(false);
  const [dragBoxId, setDragBoxId] = useState(null);
  const [modoMoverBox, setModoMoverBox] = useState(false);
  const [accesoForm, setAccesoForm] = useState({ id: null, dato_tipo: 'credencial', valor: '', clave: '', notas: '', dato_extra: '' });
  const [logsOperativos, setLogsOperativos] = useState([]);
  const [mostrarLogsOperativos, setMostrarLogsOperativos] = useState(false);
  const defaultMetricLinks = ['Servidores', 'Redes / WiFi / Ubiquiti', 'Inventario'];
  const metricStorageKey = `age_metricas_tecnico_${empresa}`;
  const [metricLinks, setMetricLinks] = useState(() => {
    try {
      const saved = localStorage.getItem(metricStorageKey);
      const parsed = saved ? JSON.parse(saved) : null;
      return Array.isArray(parsed) && parsed.length === 3 ? parsed : defaultMetricLinks;
    } catch (_) {
      return defaultMetricLinks;
    }
  });

  const cargar = useCallback(() => {
    setCargando(true);
    Promise.all([
      fetch(`${API}/api/empresa-accesos?empresa=${encodeURIComponent(empresa)}`, { headers: hdr() }).then(r => r.json()).catch(() => []),
      fetch(`${API}/api/tecnico/empresa-validaciones?empresa=${encodeURIComponent(empresa)}`, { headers: hdr() }).then(r => r.json()).catch(() => []),
      fetch(`${API}/api/tecnico/empresa-validaciones-registros?empresa=${encodeURIComponent(empresa)}`, { headers: hdr() }).then(r => r.json()).catch(() => []),
      fetch(`${API}/api/tecnico/empresa-actividades?empresa=${encodeURIComponent(empresa)}`, { headers: hdr() }).then(r => r.json()).catch(() => []),
      fetch(`${API}/api/tecnico/empresa-acceso-secciones?empresa=${encodeURIComponent(empresa)}`, { headers: hdr() }).then(r => r.json()).catch(() => []),
      fetch(`${API}/api/tecnico/empresa-config?empresa=${encodeURIComponent(empresa)}`, { headers: hdr() }).then(r => r.json()).catch(() => ({ validaciones_activas: 1 })),
    ]).then(([acc, val, reg, act, sec, cfg]) => {
      setAccesos(Array.isArray(acc) ? acc : []);
      setValidaciones(Array.isArray(val) ? val : []);
      setRegistrosVal(Array.isArray(reg) ? reg : []);
      setActividadesEmpresa(Array.isArray(act) ? act : []);
      setSeccionesAcceso(Array.isArray(sec) ? sec : []);
      setEmpresaConfig(cfg && typeof cfg === 'object' ? cfg : { validaciones_activas: 1 });
      setCargando(false);
    }).catch(() => setCargando(false));
  }, [empresa]);
  useEffect(() => { cargar(); }, [cargar]);
  useEffect(() => {
    try { localStorage.setItem(metricStorageKey, JSON.stringify(metricLinks)); } catch (_) {}
  }, [metricStorageKey, metricLinks]);

  const validacionesActivas = empresaConfig.validaciones_activas !== 0;
  const toggleValidacionesEmpresa = async () => {
    if (!isAdmin) return;
    const next = validacionesActivas ? 0 : 1;
    const r = await fetch(`${API}/api/tecnico/empresa-config`, {
      method: 'PUT',
      headers: jsonHdr(),
      body: JSON.stringify({ empresa, validaciones_activas: next })
    });
    if (r.ok) setEmpresaConfig(c => ({ ...c, validaciones_activas: next }));
    else { const d = await r.json(); alert(d.error || 'No se pudo actualizar la visualizacion'); }
  };

  const guardar = async () => {
    if (!isAdmin) return;
    const tipoFinal = form.tipo === '__otro' ? (form._custom?.trim() || '') : form.tipo;
    if (!tipoFinal) { setMsg('Selecciona un tipo'); return; }
    if (!form.valor) { setMsg('El valor es requerido'); return; }
    setMsg('');
    const url = editando ? `${API}/api/empresa-accesos/${editando}` : `${API}/api/empresa-accesos`;
    const method = editando ? 'PUT' : 'POST';
    const body = editando
      ? { tipo: tipoFinal, valor: form.valor, clave: form.clave || null }
      : { empresa, tipo: tipoFinal, valor: form.valor, clave: form.clave || null };
    const r = await fetch(url, { method, headers: jsonHdr(), body: JSON.stringify(body) });
    if (r.ok) { setForm(emptyForm); setEditando(null); cargar(); }
    else { const d = await r.json(); setMsg(d.error || 'Error'); }
  };

  const eliminar = async (id) => {
    if (!window.confirm('?Eliminar?')) return;
    await fetch(`${API}/api/empresa-accesos/${id}`, { method: 'DELETE', headers: hdr() });
    cargar();
  };



  const parseJsonSafe = (value) => {
    if (!value) return null;
    try { return typeof value === 'string' ? JSON.parse(value) : value; } catch (_) { return null; }
  };



  const abrirValidacion = (v) => {
    setValidando(v);
    setValForm({ estado: 'Correcto', observacion: '' });
  };

  const guardarValidacion = async () => {
    if (!validando) return;
    const r = await fetch(`${API}/api/tecnico/empresa-validaciones/${validando.id}/registro`, {
      method: 'POST', headers: jsonHdr(), body: JSON.stringify(valForm)
    });
    if (r.ok) { setValidando(null); setValForm({ estado: 'Correcto', observacion: '' }); cargar(); }
    else { const d = await r.json(); alert(d.error || 'No se pudo guardar'); }
  };

  const guardarActividadEmpresa = async () => {
    if (!actividadForm.actividades.trim() && !actividadForm.pendientes.trim()) {
      alert('Ingresa actividades realizadas o pendientes');
      return;
    }
    setGuardandoActividad(true);
    try {
      const r = await fetch(`${API}/api/tecnico/empresa-actividades`, {
        method: 'POST',
        headers: jsonHdr(),
        body: JSON.stringify({ ...actividadForm, empresa }),
      });
      const data = await r.json().catch(() => ({}));
      if (!r.ok) { alert(data.error || 'No se pudo guardar la actividad'); return; }
      setActividadForm({ tipo: 'Revision', estado: 'Resuelto', actividades: '', pendientes: '' });
      cargar();
    } catch (_) {
      alert('No se pudo guardar la actividad');
    } finally {
      setGuardandoActividad(false);
    }
  };

  const abrirNuevaValidacion = () => {
    setEditVal('new');
    setValAdminForm({ nombre: '', descripcion: '', frecuencia: 'Semanal', orden: (validaciones.length + 1) * 10 });
  };

  const abrirEditarValidacion = (v) => {
    setEditVal(v.id);
    setValAdminForm({ nombre: v.nombre || '', descripcion: v.descripcion || '', frecuencia: v.frecuencia || 'Semanal', orden: v.orden || 0 });
  };

  const guardarValidacionAdmin = async () => {
    if (!isAdmin) return;
    const isNew = editVal === 'new';
    const url = isNew ? `${API}/api/tecnico/empresa-validaciones` : `${API}/api/tecnico/empresa-validaciones/${editVal}`;
    const method = isNew ? 'POST' : 'PUT';
    const body = isNew ? { ...valAdminForm, empresa } : valAdminForm;
    const r = await fetch(url, { method, headers: jsonHdr(), body: JSON.stringify(body) });
    if (r.ok) { setEditVal(null); cargar(); }
    else { const d = await r.json(); alert(d.error || 'No se pudo guardar'); }
  };

  const eliminarValidacionAdmin = async (v) => {
    if (!isAdmin) return;
    if (!window.confirm(`?Quitar la validacion "${v.nombre}" de ${empresa}?`)) return;
    const r = await fetch(`${API}/api/tecnico/empresa-validaciones/${v.id}`, { method: 'DELETE', headers: hdr() });
    if (r.ok) cargar();
    else { const d = await r.json(); alert(d.error || 'No se pudo quitar'); }
  };

  const isLicenciasTitulo = (name) => String(name || '').toLowerCase().includes('licencia');
  const datoTiposOperativos = [
    { value: 'credencial', label: 'Acceso / clave', valor: 'Usuario, IP, URL o nombre', clave: 'Clave opcional', notas: 'Notas / detalle' },
    { value: 'texto', label: 'Texto / instruccion', valor: 'Titulo', clave: 'Dato corto opcional', notas: 'Texto, pasos o instrucciones' },
    { value: 'licencia', label: 'Licencia', valor: 'Equipo / usuario / producto', clave: 'Licencia o serial', notas: 'Detalle adicional o licencia secundaria' },
    { value: 'link', label: 'Link / URL', valor: 'Nombre o URL', clave: 'Usuario opcional', notas: 'Notas del enlace' },
    { value: 'contacto', label: 'Contacto', valor: 'Nombre', clave: 'Cargo', notas: 'Telefono', extra: 'Correo' },
  ];
  const datoTipoMeta = (tipo) => datoTiposOperativos.find(t => t.value === tipo) || datoTiposOperativos[0];
  const defaultDatoTipo = (sec) => isLicenciasTitulo(sec?.nombre || sec?.titulo) ? 'licencia' : 'credencial';
  const tipoDatoOperativo = (dato, sec) => dato?.dato_tipo || (isLicenciasTitulo(sec?.nombre || sec?.titulo || dato?.tipo) ? 'licencia' : (dato?.clave ? 'credencial' : 'texto'));
  const resetAccesoForm = (sec = seccionActiva) => setAccesoForm({ id: null, dato_tipo: defaultDatoTipo(sec), valor: '', clave: '', notas: '', dato_extra: '' });

  const abrirSeccion = (sec) => {
    setSeccionActiva(sec);
    setEditSeccionTitulo(false);
    setSeccionTituloForm(sec.titulo || sec.nombre || '');
    resetAccesoForm(sec);
  };

  const guardarTituloSeccion = async () => {
    if (!isAdmin || !seccionActiva?.id || String(seccionActiva.id).startsWith('tmp-')) return;
    const r = await fetch(`${API}/api/tecnico/empresa-acceso-secciones/${seccionActiva.id}`, {
      method: 'PUT', headers: jsonHdr(), body: JSON.stringify({ titulo: seccionTituloForm, orden: seccionActiva.orden || 0 })
    });
    if (r.ok) { setEditSeccionTitulo(false); setSeccionActiva(null); cargar(); }
    else { const d = await r.json(); alert(d.error || 'No se pudo guardar el titulo'); }
  };

  const crearSeccionOperativa = async () => {
    if (!isAdmin) return;
    const titulo = nuevaSeccionForm.trim();
    if (!titulo) { alert('Ingresa el nombre del box'); return; }
    const maxOrden = seccionesBase.reduce((m, sec) => Math.max(m, parseInt(sec.orden || 0, 10)), 0);
    const r = await fetch(`${API}/api/tecnico/empresa-acceso-secciones`, {
      method: 'POST', headers: jsonHdr(), body: JSON.stringify({ empresa, titulo, orden: maxOrden + 10 })
    });
    if (r.ok) { setNuevaSeccionForm(''); setMostrarNuevaSeccion(false); cargar(); }
    else { const d = await r.json(); alert(d.error || 'No se pudo crear el box'); }
  };

  const quitarSeccionOperativa = async () => {
    if (!isAdmin || !seccionActiva?.id || String(seccionActiva.id).startsWith('tmp-')) return;
    const count = seccionItems(seccionActiva).length;
    const msg = count
      ? `Este box tiene ${count} dato(s). Si lo quitas, esos datos dejaran de verse en la vista operativa. ¿Continuar?`
      : `¿Quitar el box "${seccionActiva.nombre}"?`;
    if (!window.confirm(msg)) return;
    const r = await fetch(`${API}/api/tecnico/empresa-acceso-secciones/${seccionActiva.id}`, { method: 'DELETE', headers: hdr() });
    if (r.ok) { setSeccionActiva(null); cargar(); }
    else { const d = await r.json(); alert(d.error || 'No se pudo quitar el box'); }
  };

  const moverSeccionOperativa = async (fromId, toId) => {
    if (!isAdmin || !fromId || !toId || fromId === toId) return;
    const fromIndex = grupos.findIndex(g => String(g.id) === String(fromId));
    const toIndex = grupos.findIndex(g => String(g.id) === String(toId));
    if (fromIndex < 0 || toIndex < 0) return;
    const next = [...grupos];
    const [moved] = next.splice(fromIndex, 1);
    next.splice(toIndex, 0, moved);
    setSeccionesAcceso(next.map((g, idx) => ({ id: g.id, titulo: g.titulo || g.nombre, orden: (idx + 1) * 10, activo: g.activo ?? 1 })));
    await Promise.all(next.map((g, idx) => {
      if (String(g.id).startsWith('tmp-')) return Promise.resolve();
      return fetch(`${API}/api/tecnico/empresa-acceso-secciones/${g.id}`, {
        method: 'PUT',
        headers: jsonHdr(),
        body: JSON.stringify({ titulo: g.titulo || g.nombre, orden: (idx + 1) * 10 })
      });
    }));
    cargar();
  };

  const editarAccesoEnSeccion = (a) => {
    setAccesoForm({ id: a.id, dato_tipo: tipoDatoOperativo(a, seccionActiva), valor: a.valor || '', clave: a.clave || '', notas: a.notas || '', dato_extra: a.dato_extra || '' });
    setTimeout(() => document.getElementById('form-dato-operativo')?.scrollIntoView({ behavior: 'smooth', block: 'center' }), 50);
  };


  const cargarLogsOperativos = async () => {
    if (!isAdmin) return;
    try {
      const r = await fetch(`${API}/api/tecnico/admin/empresa-accesos-log?empresa=${encodeURIComponent(empresa)}`, { headers: hdr() });
      const data = await r.json();
      setLogsOperativos(Array.isArray(data) ? data : []);
      setMostrarLogsOperativos(true);
    } catch (_) {
      alert('No se pudo cargar el log de cambios');
    }
  };

  const resumenLogOperativo = (log) => {
    const despues = parseJsonSafe(log.despues);
    const antes = parseJsonSafe(log.antes);
    const dato = despues?.tipo || antes?.tipo || 'Dato operativo';
    const valor = despues?.valor || antes?.valor || '';
    return `${dato}${valor ? ` - ${valor}` : ''}`;
  };

  const guardarAccesoSeccion = async () => {
    if (!seccionActiva) return;
    if (!accesoForm.valor.trim()) { alert('El dato es requerido'); return; }
    const tipo = seccionActiva.titulo || seccionActiva.nombre;
    const url = accesoForm.id ? `${API}/api/empresa-accesos/${accesoForm.id}` : `${API}/api/empresa-accesos`;
    const method = accesoForm.id ? 'PUT' : 'POST';
    const body = accesoForm.id
      ? { tipo, seccion_id: seccionActiva.id, dato_tipo: accesoForm.dato_tipo || defaultDatoTipo(seccionActiva), valor: accesoForm.valor, clave: accesoForm.clave || null, notas: accesoForm.notas || null, dato_extra: accesoForm.dato_extra || null }
      : { empresa, tipo, seccion_id: seccionActiva.id, dato_tipo: accesoForm.dato_tipo || defaultDatoTipo(seccionActiva), valor: accesoForm.valor, clave: accesoForm.clave || null, notas: accesoForm.notas || null, dato_extra: accesoForm.dato_extra || null };
    const r = await fetch(url, { method, headers: jsonHdr(), body: JSON.stringify(body) });
    if (r.ok) { resetAccesoForm(seccionActiva); cargar(); }
    else { const d = await r.json(); alert(d.error || 'No se pudo guardar'); }
  };

  const tiposComunes = ['Correo','IP','URL','Usuario','Telefono','Wifi','Notas','RUT/NIT','Servidor','Router','Ubiquiti','DVR'];
  const TIPO_ICON = { Correo:'??', IP:'??', URL:'??', Usuario:'??', Telefono:'??', Wifi:'??', Notas:'??', 'RUT/NIT':'??', Servidor:'??', Router:'??', Ubiquiti:'??', DVR:'??' };
  const accesoCategoriaBase = (a) => {
    const t = `${a.tipo || ''} ${a.valor || ''} ${a.notas || ''}`.toLowerCase();
    if (t.includes('servidor') || t.includes('siigo') || t.includes('datos')) return 'Servidores';
    if (t.includes('router') || t.includes('firewall') || t.includes('vpn')) return 'Routers / Firewall';
    if (t.includes('wifi') || t.includes('wi-fi') || t.includes('ubiquiti') || t.includes('ssid') || t.includes('red')) return 'Redes / WiFi / Ubiquiti';
    if (t.includes('dvr') || t.includes('camara') || t.includes('c?mara')) return 'DVR / Camaras';
    if (t.includes('correo') || t.includes('mail')) return 'Correos';
    if (t.includes('usuario') || t.includes('clave') || t.includes('password')) return 'Usuarios / Claves';
    if (t.includes('url') || t.includes('http') || t.includes('link')) return 'Links / URLs';
    if (t.includes('telefono') || t.includes('tel?fono') || t.includes('contacto')) return 'Telefonos / Contactos';
    return 'Otros';
  };
  const seccionesBase = seccionesAcceso.length ? seccionesAcceso : [
    { id: 'tmp-1', titulo: 'Servidores', orden: 10 },
    { id: 'tmp-2', titulo: 'Redes / WiFi / Ubiquiti', orden: 20 },
    { id: 'tmp-3', titulo: 'Routers / Firewall', orden: 30 },
    { id: 'tmp-4', titulo: 'DVR / Camaras', orden: 40 },
    { id: 'tmp-5', titulo: 'Correos', orden: 50 },
    { id: 'tmp-6', titulo: 'Usuarios / Claves', orden: 60 },
    { id: 'tmp-7', titulo: 'Links / URLs', orden: 70 },
    { id: 'tmp-8', titulo: 'Telefonos / Contactos', orden: 80 },
    { id: 'tmp-9', titulo: 'Otros', orden: 90 },
  ];
  const seccionItems = (sec) => accesos.filter(a => String(a.seccion_id || '') === String(sec.id || '') || a.tipo === sec.titulo || (isLicenciasTitulo(sec.titulo) && isLicenciasTitulo(a.tipo)) || accesoCategoriaBase(a) === sec.titulo);
  const grupos = seccionesBase.map(sec => ({ ...sec, nombre: sec.titulo, items: seccionItems(sec) }));
  const accesoFormMeta = datoTipoMeta(accesoForm.dato_tipo || defaultDatoTipo(seccionActiva));

  const pendientes = validaciones.filter(v => !v.ultima_validacion || v.ultimo_estado !== 'Correcto').length;
  const validadas = Math.max(validaciones.length - pendientes, 0);
  const ultimaRevision = validaciones.map(v => v.ultima_validacion).filter(Boolean).sort().pop();
  const fmtFechaHora = (v) => v ? new Date(v).toLocaleString('es-CO', { day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit' }) : 'Sin validar';
  const notificaciones = [
    ...actividadesEmpresa.map(a => ({
      id: `actividad-${a.id}`,
      clase: 'rapido',
      tipo: a.tipo || 'Actividad',
      fecha: a.created_at,
      titulo: `Actividad del dia${a.tecnico_nombre ? ` - ${a.tecnico_nombre}` : ''}`,
      detalle: [a.actividades, a.pendientes ? `Pendientes: ${a.pendientes}` : '', a.estado ? `Estado: ${a.estado}` : ''].filter(Boolean).join(' - ')
    })),
    ...registrosVal.map(r => ({
    id: `validacion-${r.id}`,
    clase: 'validacion',
    tipo: 'Validacion',
    fecha: r.created_at,
    titulo: r.validacion_nombre,
    detalle: `${r.estado || 'Registrado'}${r.tecnico_nombre ? ` por ${r.tecnico_nombre}` : ''}${r.observacion ? ` - ${r.observacion}` : ''}`
    }))
  ].sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
  const terminoHistorial = historialBusqueda.trim().toLocaleLowerCase('es');
  const notificacionesFiltradas = notificaciones.filter(n => {
    if (historialTipo === 'rapidos' && n.clase !== 'rapido') return false;
    if (!terminoHistorial) return true;
    return [n.tipo, n.titulo, n.detalle, fmtFechaHora(n.fecha)]
      .join(' ')
      .toLocaleLowerCase('es')
      .includes(terminoHistorial);
  });
  const validationBadge = (v) => {
    if (!v.ultima_validacion) return { text: 'Sin validar', bg: '#7b5b16', color: '#fff4d8' };
    if (v.ultimo_estado === 'Correcto') return { text: 'OK', bg: '#117553', color: '#d9fff3' };
    return { text: v.ultimo_estado, bg: '#7b5b16', color: '#fff4d8' };
  };
  const panel = { background: C.card, border: `1px solid ${C.border}`, borderRadius: 10, padding: 14 };
  const validationItem = { background: '#f7fafd', border: '1px solid #dce6ef', borderRadius: 8, padding: 10 };

  const metricOptions = ['Inventario', ...grupos.map(g => g.nombre)];
  const metricSource = (name) => {
    if (name === 'Inventario' || name === 'Pendientes') return { label: 'Inventario', value: inventarioTotal };
    const group = grupos.find(g => g.nombre === name) || grupos[0];
    return { label: group?.nombre || name, value: group?.items.length || 0 };
  };

  const pagePad = isPhone ? '14px 10px 34px' : '24px 16px 44px';
  const metricColumns = isPhone || isTablet ? 'repeat(2, minmax(0, 1fr))' : 'repeat(4, minmax(0, 1fr))';
  const necesitaScrollOperativo = grupos.length > (isPhone ? 3 : isTablet ? 6 : 9);
  const operativeColumns = isPhone ? '1fr' : isTablet ? 'repeat(2, minmax(0, 1fr))' : 'repeat(3, minmax(0, 1fr))';
  const operativeGridMaxHeight = isPhone ? 620 : isTablet ? 380 : 356;
  const notificationColumns = isPhone ? '1fr' : isTablet ? '110px 1fr' : '120px 145px 1fr';
  const modalBox = (maxWidth) => ({ width: '100%', maxWidth, maxHeight: isPhone ? '92vh' : '86vh', overflow: 'auto', background: C.card, border: `1px solid ${C.border}`, borderRadius: isPhone ? 10 : 14, padding: isPhone ? 14 : 20, boxSizing: 'border-box' });
  const abrirHistorialReciente = () => {
    setNotificacionesExpandido(true);
    setTimeout(() => document.getElementById('historial-reciente')?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 60);
  };
  const estadoMapaGrupo = (grupo) => {
    const items = grupo.items || [];
    const nombre = String(grupo.nombre || '').toLowerCase();
    if (!items.length) return { text: 'Sin datos', bg: '#eef3f7', color: '#667b92', border: '#dce6ef' };
    if (nombre.includes('clave') || nombre.includes('usuario') || nombre.includes('router') || nombre.includes('firewall')) return { text: 'Revisar', bg: '#fff7e6', color: '#9a5b12', border: '#f4d69a' };
    return { text: 'OK', bg: '#e7f7ef', color: '#047857', border: '#b8e2cd' };
  };

  const card = { background: 'var(--app-surface)', border: '1px solid var(--app-border)', borderRadius: 4, padding: '14px 16px', boxShadow: '0 1px 2px var(--app-shadow)' };
  const secTit = { fontSize: 10, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--app-muted)', margin: 0 };
  const tituloPlegable = (titulo, abierto, setAbierto, extra) => (
    <button type="button" onClick={() => setAbierto(v => !v)} style={{ border: 'none', background: 'transparent', padding: 0, cursor: 'pointer', fontFamily: 'inherit', display: 'flex', alignItems: 'center', gap: 8, textAlign: 'left' }}>
      <span style={secTit}>{titulo}</span>
      {extra}
      <span style={{ color: 'var(--app-muted)', fontSize: 12 }}>{abierto ? '\u25b2' : '\u25bc'}</span>
    </button>
  );
  const tagStyle = (bg, color) => ({ display: 'inline-block', fontSize: 10, fontWeight: 700, padding: '2px 7px', borderRadius: 2, background: bg, color, whiteSpace: 'nowrap' });
  const chip = (activo) => ({ fontFamily: 'inherit', fontSize: 11, fontWeight: 700, padding: '5px 12px', borderRadius: 2, cursor: 'pointer', border: `1px solid ${activo ? '#08293f' : 'var(--app-border)'}`, background: activo ? '#08293f' : 'var(--app-surface)', color: activo ? '#00b8e3' : 'var(--app-muted)' });
  const campo = { fontFamily: 'inherit', fontSize: 12, color: 'var(--app-heading)', background: 'var(--app-input, var(--app-surface))', border: '1px solid var(--app-border)', borderRadius: 2, padding: '7px 10px', width: '100%', boxSizing: 'border-box' };
  const etiquetaKpi = (oscuro) => ({ fontSize: 9, fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', color: oscuro ? 'rgba(0,184,227,0.6)' : 'var(--app-muted)', marginBottom: 3 });
  const kpi = (label, valor, oscuro = false, selector = null) => (
    <div style={{ background: oscuro ? '#08293f' : 'var(--app-surface)', border: oscuro ? '1px solid rgba(0,184,227,0.2)' : '1px solid var(--app-border)', borderRadius: 2, padding: '12px 14px' }}>
      {selector || <div style={etiquetaKpi(oscuro)}>{label}</div>}
      <div style={{ fontSize: 16, fontWeight: 700, color: oscuro ? '#00b8e3' : 'var(--app-heading)' }}>{valor}</div>
    </div>
  );
  const kpiEnlazado = (name, index) => {
    const source = metricSource(name);
    const selector = isAdmin ? (
      <select value={name} onChange={e => setMetricLinks(list => list.map((item, i) => i === index ? e.target.value : item))}
        style={{ ...etiquetaKpi(index === 0), width: '100%', minWidth: 0, maxWidth: '100%', textOverflow: 'ellipsis', border: 'none', background: 'transparent', outline: 'none', cursor: 'pointer', padding: 0, fontFamily: 'inherit' }}>
        {metricOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
      </select>
    ) : null;
    return <div key={index}>{kpi(source.label, source.value, index === 0, selector)}</div>;
  };
  const irA = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  const ultimaRevisionTexto = ultimaRevision ? fmtFechaHora(ultimaRevision) : 'Sin registro';

  return (
    <div style={{ maxWidth: embedded ? 'none' : 1130, width: embedded ? '100%' : undefined, minWidth: 0, margin: embedded ? 0 : '0 auto', padding: embedded ? 0 : pagePad, color: 'var(--app-text)' }}>
      {!embedded && (
        <div style={{ marginBottom: 14 }}>
          <button onClick={onBack} style={{ fontFamily: 'inherit', fontSize: 11, fontWeight: 600, color: 'var(--app-muted)', background: 'var(--app-bg)', border: '1px solid var(--app-border)', padding: '4px 10px', borderRadius: 2, cursor: 'pointer', marginBottom: 8 }}>{'\u2190 Volver'}</button>
          <h2 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: 'var(--app-heading)', wordBreak: 'break-word' }}>{empresa}</h2>
        </div>
      )}

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, flexWrap: 'wrap', marginBottom: 12 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
          <span style={tagStyle(pendientes > 0 ? 'rgba(251,191,36,0.16)' : 'rgba(5,150,105,0.12)', pendientes > 0 ? '#b45309' : '#059669')}>
            {pendientes > 0 ? `${pendientes} pendiente${pendientes === 1 ? '' : 's'}` : 'Operaci\u00f3n estable'}
          </span>
          <span style={{ fontSize: 11, color: 'var(--app-muted)' }}>{'\u00daltima revisi\u00f3n'}: {ultimaRevisionTexto}</span>
        </div>
        {isAdmin && (
          <button type="button" onClick={toggleValidacionesEmpresa} style={{ ...chip(validacionesActivas), padding: '4px 10px' }}>
            Validaciones: {validacionesActivas ? 'Activas' : 'Inactivas'}
          </button>
        )}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: metricColumns, gap: 8, marginBottom: 12 }}>
        {metricLinks.map((name, index) => kpiEnlazado(name, index))}
        {validacionesActivas
          ? kpi('Validaciones', <span style={tagStyle(pendientes === 0 ? 'rgba(5,150,105,0.12)' : 'rgba(251,191,36,0.16)', pendientes === 0 ? '#059669' : '#b45309')}>{validadas}/{validaciones.length} OK</span>)
          : kpi('\u00daltima revisi\u00f3n', ultimaRevision ? 'Registrada' : 'Sin registro')}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: isPhone || isTablet || !validacionesActivas ? '1fr' : 'minmax(0, 1.2fr) minmax(0, .8fr)', gap: 12, marginBottom: 12, alignItems: 'start' }}>
        {validacionesActivas && (
          <section style={card}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: validacionesAbiertas ? 6 : 0 }}>
              {tituloPlegable('\u2014 Validaciones peri\u00f3dicas', validacionesAbiertas, setValidacionesAbiertas, <span style={tagStyle(pendientes === 0 ? 'rgba(5,150,105,0.12)' : 'rgba(251,191,36,0.16)', pendientes === 0 ? '#059669' : '#b45309')}>{validadas}/{validaciones.length} OK</span>)}
              {isAdmin && validacionesAbiertas && <button onClick={abrirNuevaValidacion} style={{ ...chip(false), padding: '3px 10px' }}>+ Nueva</button>}
            </div>
            {validacionesAbiertas && <div style={{ maxHeight: 300, overflowY: 'auto' }}>
              {validaciones.map(v => {
                const b = validationBadge(v);
                const ok = b.text === 'OK';
                return (
                  <div key={v.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, padding: '9px 0', borderBottom: '1px solid var(--app-border)' }}>
                    <div style={{ minWidth: 0 }} title={v.descripcion || ''}>
                      <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--app-heading)' }}>{v.nombre}</div>
                      <div style={{ fontSize: 11, color: 'var(--app-muted)', marginTop: 1 }}>{v.frecuencia || 'Semanal'} {'\u00b7'} {fmtFechaHora(v.ultima_validacion)}{v.ultimo_tecnico ? ` \u00b7 ${v.ultimo_tecnico}` : ''}</div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
                      <span style={tagStyle(ok ? 'rgba(5,150,105,0.12)' : 'rgba(251,191,36,0.16)', ok ? '#059669' : '#b45309')}>{b.text}</span>
                      {isAdmin && <button onClick={() => abrirEditarValidacion(v)} style={{ background: 'none', border: 'none', color: '#00b8e3', cursor: 'pointer', fontSize: 11, fontWeight: 700, padding: 0, fontFamily: 'inherit' }}>Editar</button>}
                      <button onClick={() => abrirValidacion(v)} title="Registrar validacion" style={{ width: 24, height: 24, borderRadius: 2, border: `1px solid ${ok ? '#059669' : '#00b8e3'}`, background: 'transparent', color: ok ? '#059669' : '#00b8e3', cursor: 'pointer', fontWeight: 700, fontSize: 13, padding: 0 }}>{ok ? '\u2713' : '+'}</button>
                    </div>
                  </div>
                );
              })}
              {!validaciones.length && <div style={{ fontSize: 12, color: 'var(--app-muted)', padding: '10px 0' }}>Sin validaciones configuradas.</div>}
            </div>}
          </section>
        )}

        <section style={card}>
          <div style={{ marginBottom: registroAbierto ? 10 : 0 }}>{tituloPlegable('\u2014 Registro t\u00e9cnico r\u00e1pido', registroAbierto, setRegistroAbierto)}</div>
          {registroAbierto && <>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 8 }}>
            <select value={actividadForm.tipo} onChange={e => setActividadForm(f => ({ ...f, tipo: e.target.value }))} style={campo}>
              {['Revision', 'Soporte', 'Mantenimiento', 'Instalacion', 'Emergencia'].map(opt => <option key={opt} value={opt}>{opt}</option>)}
            </select>
            <select value={actividadForm.estado} onChange={e => setActividadForm(f => ({ ...f, estado: e.target.value }))} style={campo}>
              {['Resuelto', 'Parcial', 'Pendiente', 'Requiere aprobacion'].map(opt => <option key={opt} value={opt}>{opt}</option>)}
            </select>
          </div>
          <textarea value={actividadForm.actividades} onChange={e => setActividadForm(f => ({ ...f, actividades: e.target.value }))} placeholder="Actividades realizadas hoy..." rows={3} style={{ ...campo, resize: 'vertical', minHeight: 70, marginBottom: 8 }} />
          <textarea value={actividadForm.pendientes} onChange={e => setActividadForm(f => ({ ...f, pendientes: e.target.value }))} placeholder="Pendientes, novedades o recomendaciones..." rows={2} style={{ ...campo, resize: 'vertical', minHeight: 54, marginBottom: 8 }} />
          <button type="button" disabled={guardandoActividad} onClick={guardarActividadEmpresa} style={{ width: '100%', fontFamily: 'inherit', fontSize: 12, fontWeight: 700, background: '#00b8e3', color: '#040f16', border: 'none', borderRadius: 2, padding: 9, cursor: 'pointer', opacity: guardandoActividad ? 0.65 : 1 }}>
            {guardandoActividad ? 'Guardando...' : 'Guardar actividad'}
          </button>
          </>}
        </section>
      </div>

      <section id="mapa-operativo" style={{ ...card, marginBottom: 12, scrollMarginTop: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginBottom: mapaAbierto ? 12 : 0 }}>
          {tituloPlegable('\u2014 Mapa operativo', mapaAbierto, setMapaAbierto)}
          <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap', alignItems: 'center' }}>
            <span style={chip(true)}>Mapa operativo</span>
            <button type="button" onClick={() => irA('inventario-tecnico')} style={chip(false)}>Inventario</button>
            <button type="button" onClick={abrirHistorialReciente} style={chip(false)}>Historial</button>
            {isAdmin && <button type="button" onClick={() => { setMapaAbierto(true); setMostrarNuevaSeccion(v => !v); }} style={chip(false)}>+ Box</button>}
            {isAdmin && !isPhone && (
              <label style={{ ...chip(modoMoverBox), display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                <input type="checkbox" checked={modoMoverBox} onChange={e => { if (e.target.checked) setMapaAbierto(true); setModoMoverBox(e.target.checked); }} style={{ margin: 0 }} />
                Organizar
              </label>
            )}
          </div>
        </div>
        {mapaAbierto && <>
        {mostrarNuevaSeccion && isAdmin && (
          <div style={{ display: 'grid', gridTemplateColumns: isPhone ? '1fr' : '1fr auto auto', gap: 8, marginBottom: 12, background: 'var(--app-surface-soft)', border: '1px solid var(--app-border)', borderRadius: 4, padding: 10 }}>
            <input style={campo} placeholder="Nombre del nuevo box" value={nuevaSeccionForm} onChange={e => setNuevaSeccionForm(e.target.value)} onKeyDown={e => e.key === 'Enter' && crearSeccionOperativa()} />
            <button type="button" style={{ ...chip(true), padding: '7px 14px' }} onClick={crearSeccionOperativa}>Crear</button>
            <button type="button" style={{ ...chip(false), padding: '7px 14px' }} onClick={() => { setMostrarNuevaSeccion(false); setNuevaSeccionForm(''); }}>Cancelar</button>
          </div>
        )}
        <div style={{ display: 'grid', gridTemplateColumns: operativeColumns, gap: 10, overflowY: necesitaScrollOperativo ? 'auto' : 'visible', maxHeight: necesitaScrollOperativo ? operativeGridMaxHeight : 'none', alignContent: 'start' }}>
          {grupos.map(g => {
            const estado = estadoMapaGrupo(g);
            return (
              <button
                key={g.id || g.nombre}
                draggable={isAdmin && modoMoverBox && !isPhone}
                onDragStart={e => { if (!isAdmin || !modoMoverBox) return; setDragBoxId(g.id); e.dataTransfer.effectAllowed = 'move'; }}
                onDragOver={e => { if (isAdmin && modoMoverBox && dragBoxId && dragBoxId !== g.id) e.preventDefault(); }}
                onDrop={e => { e.preventDefault(); if (modoMoverBox) moverSeccionOperativa(dragBoxId, g.id); setDragBoxId(null); }}
                onDragEnd={() => setDragBoxId(null)}
                onClick={() => { if (!modoMoverBox) abrirSeccion(g); }}
                style={{
                  background: 'var(--app-surface)', color: 'var(--app-text)', borderRadius: 4, padding: 0,
                  border: dragBoxId === g.id ? '1px dashed #00b8e3' : '1px solid var(--app-border)',
                  textAlign: 'left', cursor: isAdmin && modoMoverBox && !isPhone ? 'grab' : 'pointer', fontFamily: 'inherit',
                  display: 'flex', flexDirection: 'column', alignItems: 'stretch', overflow: 'hidden',
                  opacity: dragBoxId && dragBoxId !== g.id ? 0.9 : 1,
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, padding: '10px 12px', background: 'var(--app-surface-soft)', borderBottom: '1px solid var(--app-border)', borderTop: '2px solid #00b8e3' }}>
                  <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--app-heading)' }}>{g.nombre}</span>
                  <span style={{ fontSize: 10, fontWeight: 700, padding: '1px 8px', borderRadius: 10, background: 'var(--app-border)', color: 'var(--app-muted)', whiteSpace: 'nowrap' }}>{g.items.length}</span>
                </div>
                {g.items.length ? g.items.slice(0, 2).map(a => (
                  <div key={a.id} style={{ display: 'flex', justifyContent: 'space-between', gap: 8, padding: '9px 12px', borderBottom: '1px solid var(--app-border)' }}>
                    <div style={{ minWidth: 0 }}>
                      <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--app-heading)' }}>{a.tipo}</div>
                      <div style={{ fontSize: 11, color: 'var(--app-muted)', marginTop: 2, wordBreak: 'break-word' }}>{a.valor}</div>
                    </div>
                    <span style={{ ...(a.clave ? tagStyle('rgba(251,191,36,0.16)', '#b45309') : estado.text === 'OK' ? tagStyle('rgba(5,150,105,0.12)', '#059669') : tagStyle('rgba(251,191,36,0.16)', '#b45309')), height: 'fit-content' }}>{a.clave ? 'Clave' : estado.text}</span>
                  </div>
                )) : (
                  <div style={{ padding: '12px', fontSize: 12, color: 'var(--app-muted)' }}>Sin datos registrados</div>
                )}
                {g.items.length > 2 && <div style={{ padding: '7px 12px', fontSize: 11, fontWeight: 700, color: '#00b8e3' }}>+ {g.items.length - 2} dato{g.items.length - 2 === 1 ? '' : 's'} m{'\u00e1'}s</div>}
              </button>
            );
          })}
        </div>
        </>}
      </section>

      <InventarioEquipos empresa={empresa} fuente="tecnico" canDelete={canDeleteInventory} canUnificar={isAdmin} onCambio={lista => setInventarioTotal(lista.length)} />

      <section id="historial-reciente" style={{ ...card, marginBottom: 14, scrollMarginTop: 16 }}>
        <button type="button" onClick={() => setNotificacionesExpandido(v => !v)} style={{ border: 'none', background: 'transparent', textAlign: 'left', padding: 0, cursor: 'pointer', fontFamily: 'inherit', width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10 }}>
          <span>
            <span style={secTit}>{'\u2014 Historial reciente'}</span>
            <span style={{ display: 'block', color: 'var(--app-muted)', fontSize: 11, marginTop: 3 }}>Actividades del d{'\u00ed'}a, validaciones, mantenimientos e inventario reciente.</span>
          </span>
          <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ fontSize: 10, fontWeight: 700, padding: '1px 8px', borderRadius: 10, background: 'var(--app-border)', color: 'var(--app-muted)' }}>{notificacionesFiltradas.length}/{notificaciones.length}</span>
            <span style={{ color: 'var(--app-muted)', fontSize: 12 }}>{notificacionesExpandido ? '\u25b2' : '\u25bc'}</span>
          </span>
        </button>
        {notificacionesExpandido && <div style={{ display: 'grid', gap: 8, marginTop: 12 }}>
          <div style={{ display: 'grid', gridTemplateColumns: isPhone ? '1fr' : '1fr 220px', gap: 8 }}>
            <input value={historialBusqueda} onChange={e => setHistorialBusqueda(e.target.value)} placeholder="Buscar en historial..." style={campo} />
            <select value={historialTipo} onChange={e => setHistorialTipo(e.target.value)} style={campo}>
              <option value="todos">Todo el historial</option>
              <option value="rapidos">Solo registros rapidos</option>
            </select>
          </div>
          {notificacionesFiltradas.map(n => (
            <div key={n.id} style={{ display: 'grid', gridTemplateColumns: notificationColumns, gap: 10, alignItems: 'start', background: 'var(--app-surface-soft)', border: '1px solid var(--app-border)', borderRadius: 4, padding: 10 }}>
              <span style={{ ...tagStyle('rgba(0,184,227,0.12)', '#0087a8'), justifySelf: 'start' }}>{n.tipo}</span>
              <b style={{ color: 'var(--app-heading)', fontSize: 12 }}>{fmtFechaHora(n.fecha)}</b>
              <div>
                <b style={{ color: 'var(--app-heading)', display: 'block', fontSize: 13 }}>{n.titulo}</b>
                <p style={{ margin: '4px 0 0', color: 'var(--app-muted)', fontSize: 12, lineHeight: 1.4 }}>{n.detalle}</p>
              </div>
            </div>
          ))}
          {!notificaciones.length && <div style={{ color: 'var(--app-muted)', fontSize: 12 }}>Aqui se mostraran validaciones, mantenimientos e inventario.</div>}
          {notificaciones.length > 0 && !notificacionesFiltradas.length && <div style={{ color: 'var(--app-muted)', fontSize: 12 }}>No hay resultados con ese filtro.</div>}
        </div>}
      </section>

      {seccionActiva && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9998, padding: 16 }}>
          <div style={{ ...modalBox(760), background: '#fff', color: '#12324d', borderColor: '#dce6ef' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, alignItems: 'flex-start', marginBottom: 14 }}>
              <div style={{ flex: 1 }}>
                {editSeccionTitulo && isAdmin ? (
                  <div style={{ display: 'grid', gridTemplateColumns: isPhone ? '1fr' : '1fr auto', gap: 8 }}>
                    <input style={{ ...s.input, borderColor: '#cfdde8' }} value={seccionTituloForm} onChange={e => setSeccionTituloForm(e.target.value)} />
                    <button style={s.btn(C.accent)} onClick={guardarTituloSeccion}>Guardar</button>
                  </div>
                ) : (
                  <h3 style={{ margin: 0, color: '#0b304b', fontSize: 22 }}>{seccionActiva.nombre}</h3>
                )}
                {isAdmin && !editSeccionTitulo && <button style={{ background: 'none', border: 'none', color: C.accent, padding: '6px 0 0', cursor: 'pointer', fontWeight: 800, fontSize: 12 }} onClick={() => setEditSeccionTitulo(true)}>Editar titulo</button>}
              </div>
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                {isAdmin && !String(seccionActiva.id || '').startsWith('tmp-') && <button style={{ ...s.btnSm(C.red) }} onClick={quitarSeccionOperativa}>Quitar box</button>}
                <button style={{ ...s.btnSm('#e7eef6'), color: '#143a57' }} onClick={() => setSeccionActiva(null)}>Cerrar</button>
              </div>
            </div>

            <div style={{ display: 'grid', gap: 8, marginBottom: 16 }}>
              {seccionItems(seccionActiva).map(a => {
                const datoTipo = tipoDatoOperativo(a, seccionActiva);
                const tipoMeta = datoTipoMeta(datoTipo);
                const isLicencia = datoTipo === 'licencia';
                const isTexto = datoTipo === 'texto';
                const isLink = datoTipo === 'link';
                const isContacto = datoTipo === 'contacto';
                const contactCorreo = isContacto ? (a.dato_extra || '') : '';
                const clavePareceTelefono = /^[+\d\s().-]{6,}$/.test(String(a.clave || '').trim());
                const contactCargo = isContacto ? (a.notas || contactCorreo || !clavePareceTelefono ? (a.clave || '') : '') : '';
                const contactTelefono = isContacto ? (a.notas || (clavePareceTelefono ? a.clave : '') || '') : '';
                const windowsVisible = mostrarClave[a.id];
                const officeVisible = mostrarClave[`office-${a.id}`];
                return (
                <div key={a.id} style={{ background: '#f7fafd', border: '1px solid #dce6ef', borderRadius: 9, padding: 10 }}>
                  {isLicencia ? (
                    <div style={{ display: 'grid', gridTemplateColumns: isPhone ? '1fr' : '1fr 1.35fr 1.35fr auto', gap: 10, alignItems: 'center' }}>
                      <div>
                        <div style={{ color: '#7b8fa7', fontSize: 10, fontWeight: 900, textTransform: 'uppercase', letterSpacing: 1 }}>Equipo / Usuario</div>
                        <div style={{ color: '#0b304b', fontWeight: 900, fontSize: 14, marginTop: 4 }}>{a.valor}</div>
                      </div>
                      <div>
                        <div style={{ color: '#7b8fa7', fontSize: 10, fontWeight: 900, textTransform: 'uppercase', letterSpacing: 1 }}>Licencia Windows</div>
                        <div style={{ display: 'flex', gap: 6, alignItems: 'center', marginTop: 4, flexWrap: 'wrap' }}>
                          <span style={{ color: '#274762', fontSize: 12, fontWeight: 800, letterSpacing: windowsVisible ? 0 : 2, wordBreak: 'break-all' }}>{a.clave ? (windowsVisible ? a.clave : 'XXXXX-XXXXX-XXXXX-XXXXX-XXXXX') : '-'}</span>
                          {a.clave && <button type="button" style={{ ...s.btnSm('#e7eef6'), color: '#143a57', padding: '4px 7px' }} onClick={() => setMostrarClave(m => ({ ...m, [a.id]: !m[a.id] }))}>{windowsVisible ? 'Ocultar' : 'Ver'}</button>}
                          {a.clave && windowsVisible && <CopyBtn text={a.clave} />}
                        </div>
                      </div>
                      <div>
                        <div style={{ color: '#7b8fa7', fontSize: 10, fontWeight: 900, textTransform: 'uppercase', letterSpacing: 1 }}>Licencia Office</div>
                        <div style={{ display: 'flex', gap: 6, alignItems: 'center', marginTop: 4, flexWrap: 'wrap' }}>
                          <span style={{ color: '#274762', fontSize: 12, fontWeight: 800, letterSpacing: officeVisible ? 0 : 2, wordBreak: 'break-all' }}>{a.notas ? (officeVisible ? a.notas : 'XXXXX-XXXXX-XXXXX-XXXXX-XXXXX') : '-'}</span>
                          {a.notas && <button type="button" style={{ ...s.btnSm('#e7eef6'), color: '#143a57', padding: '4px 7px' }} onClick={() => setMostrarClave(m => ({ ...m, [`office-${a.id}`]: !m[`office-${a.id}`] }))}>{officeVisible ? 'Ocultar' : 'Ver'}</button>}
                          {a.notas && officeVisible && <CopyBtn text={a.notas} />}
                        </div>
                      </div>
                      <div style={{ display: 'grid', gridTemplateColumns: isPhone ? 'repeat(2, minmax(0, 1fr))' : 'repeat(2, auto)', gap: 6, justifyContent: 'end' }}>
                        <button type="button" style={{ ...s.btnSm('#143a57'), minWidth: 72 }} onClick={() => editarAccesoEnSeccion(a)}>Editar</button>
                        <button type="button" style={{ ...s.btnSm(C.red), minWidth: 72 }} onClick={() => eliminar(a.id)}>Quitar</button>
                      </div>
                    </div>
                  ) : (
                    <div style={{ display: 'grid', gridTemplateColumns: isPhone ? '1fr' : 'minmax(0, 1fr) auto', gap: 10, alignItems: 'start' }}>
                      <div style={{ minWidth: 0 }}>
                        <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', marginBottom: 5 }}>
                          <div style={{ color: '#0b304b', fontWeight: 900, fontSize: 14, lineHeight: 1.35, wordBreak: 'break-word' }}>{a.valor}</div>
                          <span style={{ background: '#e8f6fd', color: C.accent, border: '1px solid #bde9f7', borderRadius: 999, padding: '2px 7px', fontSize: 10, fontWeight: 900 }}>{tipoMeta.label}</span>
                        </div>
                        {isContacto ? (
                          <div style={{ display: 'grid', gap: 4, color: '#667b92', fontSize: 12, lineHeight: 1.4 }}>
                            {contactCargo && <div><b style={{ color: '#274762' }}>Cargo:</b> {contactCargo}</div>}
                            {contactTelefono && <div><b style={{ color: '#274762' }}>Telefono:</b> {contactTelefono}</div>}
                            {contactCorreo && <div><b style={{ color: '#274762' }}>Correo:</b> {contactCorreo}</div>}
                          </div>
                        ) : (
                          <>
                            {a.notas && <div style={{ color: '#667b92', fontSize: 12, marginTop: 5, lineHeight: 1.5, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{a.notas}</div>}
                            {a.clave && <div style={{ color: '#667b92', fontSize: 12, marginTop: 7 }}>{isTexto ? 'Dato corto' : isLink ? 'Usuario' : 'Clave'}: {mostrarClave[a.id] ? a.clave : '??????'}</div>}
                          </>
                        )}
                      </div>
                      <div style={{ display: 'grid', gridTemplateColumns: isPhone ? 'repeat(2, minmax(0, 1fr))' : 'repeat(4, auto)', gap: 6, alignItems: 'center' }}>
                        {a.clave && !isContacto && <button type="button" style={{ ...s.btnSm('#e7eef6'), color: '#143a57', minWidth: 72 }} onClick={() => setMostrarClave(m => ({ ...m, [a.id]: !m[a.id] }))}>{mostrarClave[a.id] ? 'Ocultar' : 'Ver'}</button>}
                        <CopyBtn text={a.valor} />
                        {isContacto && contactTelefono && <CopyBtn text={contactTelefono} />}
                        {isContacto && contactCorreo && <CopyBtn text={contactCorreo} />}
                        {a.notas && !isTexto && !isContacto && <CopyBtn text={a.notas} />}
                        <button type="button" style={{ ...s.btnSm('#143a57'), minWidth: 72 }} onClick={() => editarAccesoEnSeccion(a)}>Editar</button>
                        <button type="button" style={{ ...s.btnSm(C.red), minWidth: 72 }} onClick={() => eliminar(a.id)}>Quitar</button>
                      </div>
                    </div>
                  )}
                </div>
                );
              })}
              {!seccionItems(seccionActiva).length && <div style={{ color: '#667b92', fontSize: 13, background: '#f7fafd', border: '1px solid #dce6ef', borderRadius: 9, padding: 12 }}>Sin datos registrados en esta seccion.</div>}
            </div>

            <div id="form-dato-operativo" style={{ background: '#f7fafd', border: '1px solid #dce6ef', borderRadius: 10, padding: 14, scrollMarginTop: 20 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, alignItems: 'center', marginBottom: 8, flexWrap: 'wrap' }}>
                  <div style={{ ...s.secTitle, marginBottom: 0 }}>{accesoForm.id ? 'Editar dato' : 'Agregar dato'}</div>
                  {isAdmin && <button type="button" style={{ ...s.btnSm('#e7eef6'), color: '#143a57', padding: '5px 9px' }} onClick={cargarLogsOperativos}>Log de cambios</button>}
                </div>
                <div style={{ color: '#667b92', fontSize: 11, marginBottom: 10 }}>Crear, editar o quitar datos queda registrado con usuario, fecha y accion.</div>
                {isLicenciasTitulo(seccionActiva?.nombre) && <div style={{ color: '#0b304b', fontSize: 12, fontWeight: 800, marginBottom: 8 }}>En esta seccion: dato = equipo/usuario, clave = licencia Windows, notas = licencia Office.</div>}
                <div style={{ display: 'grid', gridTemplateColumns: isPhone ? '1fr' : '220px 1fr', gap: 10, marginBottom: 10 }}>
                  <select style={{ ...s.select, borderColor: '#cfdde8' }} value={accesoForm.dato_tipo || defaultDatoTipo(seccionActiva)} onChange={e => setAccesoForm(f => ({ ...f, dato_tipo: e.target.value, dato_extra: e.target.value === 'contacto' ? f.dato_extra : '' }))}>
                    {datoTiposOperativos.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
                  </select>
                  <div style={{ color: '#667b92', fontSize: 12, lineHeight: 1.35, alignSelf: 'center' }}>
                    Elige como se debe leer este dato dentro del box.
                  </div>
                </div>
                {accesoForm.dato_tipo === 'contacto' ? (
                  <div style={{ display: 'grid', gridTemplateColumns: isPhone ? '1fr' : '1fr 1fr', gap: 10 }}>
                    <input style={{ ...s.input, borderColor: '#cfdde8' }} placeholder="Nombre" value={accesoForm.valor} onChange={e => setAccesoForm(f => ({ ...f, valor: e.target.value }))} />
                    <input style={{ ...s.input, borderColor: '#cfdde8' }} placeholder="Cargo" value={accesoForm.clave} onChange={e => setAccesoForm(f => ({ ...f, clave: e.target.value }))} />
                    <input style={{ ...s.input, borderColor: '#cfdde8' }} placeholder="Telefono" value={accesoForm.notas} onChange={e => setAccesoForm(f => ({ ...f, notas: e.target.value }))} />
                    <input style={{ ...s.input, borderColor: '#cfdde8' }} placeholder="Correo" value={accesoForm.dato_extra} onChange={e => setAccesoForm(f => ({ ...f, dato_extra: e.target.value }))} />
                  </div>
                ) : (
                  <>
                    <div style={{ display: 'grid', gridTemplateColumns: isPhone ? '1fr' : '1.2fr 1fr', gap: 10, marginBottom: 10 }}>
                      <input style={{ ...s.input, borderColor: '#cfdde8' }} placeholder={accesoFormMeta.valor} value={accesoForm.valor} onChange={e => setAccesoForm(f => ({ ...f, valor: e.target.value }))} />
                      <input style={{ ...s.input, borderColor: '#cfdde8' }} placeholder={accesoFormMeta.clave} value={accesoForm.clave} onChange={e => setAccesoForm(f => ({ ...f, clave: e.target.value }))} />
                    </div>
                    <textarea style={{ ...s.input, borderColor: '#cfdde8', minHeight: accesoForm.dato_tipo === 'texto' ? 110 : 70, resize: 'vertical' }} placeholder={accesoFormMeta.notas} value={accesoForm.notas} onChange={e => setAccesoForm(f => ({ ...f, notas: e.target.value }))} />
                  </>
                )}
                <div style={{ display: 'flex', gap: 8, marginTop: 10, flexWrap: 'wrap' }}>
                  <button style={s.btn(C.accent)} onClick={guardarAccesoSeccion}>{accesoForm.id ? 'Guardar cambios' : 'Agregar dato'}</button>
                  {accesoForm.id && <button style={{ ...s.btn('#e7eef6'), color: '#143a57' }} onClick={() => resetAccesoForm(seccionActiva)}>Cancelar edicion</button>}
                </div>
              </div>
          </div>
        </div>
      )}


      {mostrarLogsOperativos && isAdmin && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10000, padding: 16 }}>
          <div style={modalBox(760)}>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, alignItems: 'center', marginBottom: 14 }}>
              <div>
                <h3 style={{ margin: 0, color: C.text }}>Log de cambios operativos</h3>
                <div style={{ color: C.muted, fontSize: 12, marginTop: 4 }}>{empresa}</div>
              </div>
              <button style={s.btnSm('#1e3a50')} onClick={() => setMostrarLogsOperativos(false)}>Cerrar</button>
            </div>
            <div style={{ display: 'grid', gap: 8, maxHeight: 460, overflowY: 'auto', paddingRight: 3 }}>
              {logsOperativos.map(log => (
                <div key={log.id} style={{ background: '#0a2235', border: `1px solid ${C.border}`, borderRadius: 9, padding: 10 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, flexWrap: 'wrap' }}>
                    <b style={{ color: C.text, textTransform: 'capitalize' }}>{log.accion}</b>
                    <span style={{ color: C.muted, fontSize: 12 }}>{fmtFechaHora(log.created_at)}</span>
                  </div>
                  <div style={{ color: C.accent, fontSize: 12, marginTop: 4 }}>{log.usuario_nombre || 'Usuario'} ? {log.usuario_rol || ''}</div>
                  <div style={{ color: C.muted, fontSize: 13, marginTop: 6, wordBreak: 'break-word' }}>{resumenLogOperativo(log)}</div>
                </div>
              ))}
              {!logsOperativos.length && <div style={{ color: C.muted, fontSize: 13 }}>Aun no hay cambios registrados.</div>}
            </div>
          </div>
        </div>
      )}

      {editVal && isAdmin && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999, padding: 16 }}>
          <div style={modalBox(500)}>
            <h3 style={{ margin: '0 0 6px', color: C.text }}>{editVal === 'new' ? 'Nueva validacion' : 'Editar validacion'}</h3>
            <div style={{ color: C.muted, fontSize: 13, marginBottom: 14 }}>{empresa}</div>
            <label style={s.label}>Nombre</label>
            <input style={s.input} value={valAdminForm.nombre} onChange={e => setValAdminForm(f => ({ ...f, nombre: e.target.value }))} placeholder="Ej: Backup NAS principal" />
            <label style={{ ...s.label, marginTop: 12 }}>Descripcion</label>
            <textarea style={{ ...s.input, minHeight: 78, resize: 'vertical' }} value={valAdminForm.descripcion} onChange={e => setValAdminForm(f => ({ ...f, descripcion: e.target.value }))} placeholder="Que debe validar el tecnico" />
            <div style={{ marginTop: 12 }}>
              <label style={s.label}>Frecuencia</label>
              <select style={s.select} value={valAdminForm.frecuencia} onChange={e => setValAdminForm(f => ({ ...f, frecuencia: e.target.value }))}>
                <option>Semanal</option>
                <option>Quincenal</option>
                <option>Mensual</option>
                <option>Trimestral</option>
                <option>Eventual</option>
              </select>
            </div>
            <div style={{ display: 'flex', gap: 8, marginTop: 14, flexWrap: 'wrap' }}>
              <button style={s.btn(C.accent)} onClick={guardarValidacionAdmin}>Guardar</button>
              {editVal !== 'new' && <button style={s.btn(C.red)} onClick={() => { const v = validaciones.find(x => x.id === editVal); setEditVal(null); if (v) eliminarValidacionAdmin(v); }}>Quitar</button>}
              <button style={s.btn('#1e3a50')} onClick={() => setEditVal(null)}>Cancelar</button>
            </div>
          </div>
        </div>
      )}

      {validando && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999, padding: 16 }}>
          <div style={modalBox(460)}>
            <h3 style={{ margin: '0 0 6px', color: C.text }}>Registrar validacion</h3>
            <div style={{ color: C.muted, fontSize: 13, marginBottom: 14 }}>{validando.nombre}</div>
            <label style={s.label}>Estado</label>
            <select style={s.select} value={valForm.estado} onChange={e => setValForm(f => ({ ...f, estado: e.target.value }))}>
              <option>Correcto</option>
              <option>Con novedad</option>
              <option>No se pudo validar</option>
            </select>
            <label style={{ ...s.label, marginTop: 12 }}>Observacion</label>
            <textarea style={{ ...s.input, minHeight: 90, resize: 'vertical' }} placeholder="Ej: respaldo correcto, DVR con hora desfasada..." value={valForm.observacion} onChange={e => setValForm(f => ({ ...f, observacion: e.target.value }))} />
            <div style={{ display: 'flex', gap: 8, marginTop: 14, flexWrap: 'wrap' }}>
              <button style={s.btn(C.accent)} onClick={guardarValidacion}>Guardar registro</button>
              <button style={s.btn('#1e3a50')} onClick={() => setValidando(null)}>Cancelar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function badgeStyle(bg, color) {
  return { display: 'inline-flex', alignItems: 'center', borderRadius: 999, padding: '4px 8px', background: bg, color, fontSize: 11, fontWeight: 800, border: '1px solid rgba(255,255,255,.08)' };
}
function lightTab(active) {
  return { background: active ? '#0b344f' : '#e8eef5', color: active ? '#fff' : '#536a84', padding: '8px 11px', borderRadius: 8, fontSize: 12, fontWeight: 800 };
}
function renderAccesoCard(a, TIPO_ICON, mostrarClave, setMostrarClave, isAdmin, setEditando, setForm, eliminar) {
  const icon = TIPO_ICON[a.tipo] || '??';
  return (
    <div key={a.id} style={{ background: 'linear-gradient(135deg, #0d2b40 0%, #0a2235 100%)', borderRadius: 10, border: '1px solid rgba(0,184,227,0.15)', overflow: 'hidden' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 12px', borderBottom: '1px solid rgba(255,255,255,0.06)', background: 'rgba(0,184,227,0.07)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}><span style={{ fontSize: 15 }}>{icon}</span><span style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: C.accent }}>{a.tipo}</span></div>
        {isAdmin && <div style={{ display: 'flex', gap: 5 }}><button style={s.btnSm('#1e3a50')} title="Editar" onClick={() => { setEditando(a.id); setForm({ tipo: a.tipo, valor: a.valor, clave: a.clave || '', _custom: '' }); }}>??</button><button style={s.btnSm(C.red+'33')} title="Eliminar" onClick={() => eliminar(a.id)}>??</button></div>}
      </div>
      <div style={{ padding: '10px 12px' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}><div style={{ fontSize: 14, fontWeight: 600, color: '#fff', wordBreak: 'break-all', flex: 1 }}>{a.valor}</div><CopyBtn text={a.valor} /></div>
        {a.clave && <div style={{ marginTop: 8, paddingTop: 8, borderTop: '1px solid rgba(255,255,255,0.06)', display: 'flex', alignItems: 'center', gap: 8 }}><span style={{ fontSize: 10, fontWeight: 700, color: C.muted, letterSpacing: '0.06em', whiteSpace: 'nowrap' }}>CLAVE</span><span style={{ flex: 1, fontSize: 13, fontWeight: 600, letterSpacing: mostrarClave[a.id] ? 0 : 3, color: mostrarClave[a.id] ? '#fff' : C.muted }}>{mostrarClave[a.id] ? a.clave : '??????'}</span><button style={{ background: 'none', border: 'none', cursor: 'pointer', color: C.muted, fontSize: 13, padding: '0 2px' }} onClick={() => setMostrarClave(m => ({ ...m, [a.id]: !m[a.id] }))}>{mostrarClave[a.id] ? '??' : '??'}</button>{mostrarClave[a.id] && <CopyBtn text={a.clave} />}</div>}
      </div>
    </div>
  );
}

function iniciales(nombre) {
  const palabras = String(nombre || '').trim().split(/\s+/).filter(Boolean);
  const letras = palabras.length > 1 ? palabras[0][0] + palabras[1][0] : (palabras[0] || '').slice(0, 2);
  return letras.toUpperCase();
}

function TabEmpresas({ isAdmin, canDeleteInventory, fichaCompleta }) {
  const [empresas, setEmpresas] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [usuarioSel, setUsuarioSel] = useState('');
  const [seleccionada, setSeleccionada] = useState(() => { try { return localStorage.getItem('age_tecnico_empresa_actual') || null; } catch (_) { return null; } });
  const [buscar, setBuscar] = useState('');
  const [gruposAbiertos, setGruposAbiertos] = useState({ 'Empresas': true, 'Pedidos empresariales': false, 'Ageinformatica / Usuarios independientes': true });

  const cargarUsuarios = useCallback(() => {
    if (!isAdmin) return;
    fetch(`${API}/api/usuarios/tecnicos`, { headers: hdr() })
      .then(r => r.json())
      .then(d => {
        const list = Array.isArray(d) ? d : [];
        setUsuarios(list);
        setUsuarioSel(prev => prev || String(list[0]?.id || ''));
      })
      .catch(() => {});
  }, [isAdmin]);

  const cargar = useCallback(() => {
    const qs = isAdmin && usuarioSel ? `?usuario_id=${encodeURIComponent(usuarioSel)}` : '';
    fetch(`${API}/api/empresas-lista${qs}`, { headers: hdr() })
      .then(r => r.json()).then(d => setEmpresas(Array.isArray(d) ? d : [])).catch(() => {});
  }, [isAdmin, usuarioSel]);

  useEffect(() => { cargarUsuarios(); }, [cargarUsuarios]);
  useEffect(() => { if (!isAdmin || usuarioSel) cargar(); }, [cargar, isAdmin, usuarioSel]);

  const volverATablero = () => { try { localStorage.removeItem('age_tecnico_empresa_actual'); } catch (_) {} setSeleccionada(null); };
  // Una sola ficha por cliente: quien puede ver Clientes abre la ficha completa (con la pestana
  // Tecnico); el tecnico, que no ve datos financieros, abre solo la parte tecnica.
  if (seleccionada && fichaCompleta) return <DetalleCliente nombre={seleccionada} tabInicial="tecnico" volverLabel="Volver a empresas" onClose={volverATablero} onRenombrado={volverATablero} />;
  if (seleccionada) return <EmpresaDetalle empresa={seleccionada} isAdmin={isAdmin} canDeleteInventory={canDeleteInventory} onBack={volverATablero} />;

  const grupoOrden = ['Empresas', 'Pedidos empresariales', 'Ageinformatica / Usuarios independientes'];
  const filtrar = (e) => !buscar || e.nombre.toLowerCase().includes(buscar.toLowerCase());
  const visibles = empresas.filter(e => isAdmin ? e.tecnico_visible : true).filter(filtrar);
  const porGrupo = (lista) => grupoOrden.map(grupo => ({ grupo, items: lista.filter(e => (e.grupo || 'Ageinformatica / Usuarios independientes') === grupo) }));
  const toggleGrupo = (grupo) => setGruposAbiertos(g => ({ ...g, [grupo]: !g[grupo] }));

  const renderGrupo = ({ grupo, items }) => !items.length ? null : (
    <section key={grupo} style={{ marginBottom: 16 }}>
      <button className="admin-landing-section-title" onClick={() => toggleGrupo(grupo)} style={{ width: '100%', background: 'transparent', color: 'rgba(255,255,255,0.32)', border: 'none', borderRadius: 8, padding: '4px 0 8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer', fontFamily: 'inherit', fontWeight: 900, textTransform: 'uppercase', letterSpacing: 1, fontSize: 12 }}>
        <span>{grupo} ({items.length})</span><span>{gruposAbiertos[grupo] ? '-' : '+'}</span>
      </button>
      {gruposAbiertos[grupo] && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: 10, marginTop: 8 }}>
          {items.map(emp => (
            <div key={emp.nombre} style={{ position: 'relative' }}>
              <button className="admin-landing-card" onClick={() => { try { localStorage.setItem('age_tecnico_empresa_actual', emp.nombre); } catch (_) {} setSeleccionada(emp.nombre); }}
                style={{ width: '100%', height: '100%', minHeight: 118, padding: '16px 10px', background: 'rgba(0,184,227,0.06)', border: '1px solid rgba(0,184,227,0.2)', borderRadius: 8, cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 9, transition: 'all 0.2s', fontFamily: 'inherit' }}
                onMouseEnter={ev => { ev.currentTarget.style.background = 'rgba(0,184,227,0.13)'; ev.currentTarget.style.borderColor = 'rgba(0,184,227,0.5)'; }}
                onMouseLeave={ev => { ev.currentTarget.style.background = 'rgba(0,184,227,0.06)'; ev.currentTarget.style.borderColor = 'rgba(0,184,227,0.2)'; }}>
                <span style={{ width: 44, height: 44, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', borderRadius: 6, background: 'rgba(0,184,227,0.12)', color: '#00b8e3', fontSize: 15, fontWeight: 900, letterSpacing: '0.08em' }}>{iniciales(emp.nombre)}</span>
                <span className="admin-landing-card-title" style={{ fontSize: 13, fontWeight: 600, color: '#fff', textAlign: 'center', wordBreak: 'break-word' }}>{emp.nombre}</span>
                {emp.descripcion && <span className="admin-landing-card-desc" style={{ fontSize: 11, color: 'rgba(255,255,255,0.45)', textAlign: 'center', lineHeight: 1.4 }}>{emp.descripcion}</span>}
              </button>
            </div>
          ))}
        </div>
      )}
    </section>
  );

  return (
    <div style={s.wrap}>
      <div style={{ textAlign: 'center', marginBottom: 22 }}>
        <div style={{ fontSize: 11, fontWeight: 600, color: 'rgba(0,184,227,0.75)', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 6 }}>Empresas</div>
        <div className="admin-landing-heading" style={{ fontSize: 22, fontWeight: 700, color: '#fff', marginBottom: 4 }}>Selecciona una empresa</div>
        <div className="admin-landing-muted" style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)' }}>{visibles.length} {visibles.length === 1 ? 'empresa' : 'empresas'}</div>
      </div>
      {isAdmin && (
        <div style={{ marginBottom: 12 }}>
          <label style={{ ...s.label, color: '#7b8fa7' }}>Visualizacion de usuario</label>
          <select style={{ ...s.select, background: '#fff', color: '#12324d', border: '1px solid #d3e0ec', maxWidth: 360 }} value={usuarioSel} onChange={e => setUsuarioSel(e.target.value)}>
            {usuarios.map(u => <option key={u.id} value={u.id}>{u.nombre} - {u.rol}</option>)}
          </select>
        </div>
      )}
      <div style={{ display: 'flex', gap: 10, marginBottom: 16, alignItems: 'center', flexWrap: 'wrap' }}>
        <input style={{ ...s.input, flex: 1, minWidth: 160 }} placeholder="Buscar empresa..." value={buscar} onChange={e => setBuscar(e.target.value)} />
      </div>
      {porGrupo(visibles).map(g => renderGrupo(g))}
      {visibles.length === 0 && <div style={{ color: C.muted, textAlign: 'center', padding: 40, fontSize: 14 }}>{buscar ? 'Sin resultados' : 'No hay empresas visibles para este usuario.'}</div>}
    </div>
  );
}

// ─── Programación ─────────────────────────────────────────────────────────────

function EventoCard({ evento, onClick, compact }) {
  const color = evento.color || '#00b8e3';
  const titulo = evento.empresa || evento.titulo || evento.descripcion || 'Evento';
  return (
    <div onClick={onClick} style={{ background: color + '22', border: `1px solid ${color}55`, borderLeft: `3px solid ${color}`, borderRadius: 6, padding: compact ? '4px 7px' : '8px 10px', cursor: onClick ? 'pointer' : 'default', userSelect: 'none' }}>
      {(evento.hora_inicio || evento.hora_fin) && (
        <div style={{ fontSize: 10, color, fontWeight: 700, marginBottom: 2 }}>
          {evento.hora_inicio}{evento.hora_fin ? ` — ${evento.hora_fin}` : ''}
        </div>
      )}
      <div style={{ fontSize: compact ? 11 : 13, fontWeight: 700, color: C.text, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {titulo}
      </div>
      {evento.descripcion && (
        <div style={{ fontSize: 11, color: C.muted, marginTop: 3, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{evento.descripcion}</div>
      )}
    </div>
  );
}

function ModalEvento({ modal, empresas, onGuardar, onEliminar, onClose, canEdit }) {
  const ev = modal.evento;
  const [empresa,    setEmpresa]    = useState(ev?.empresa     || '');
  const [titulo,     setTitulo]     = useState(ev?.titulo      || (!ev?.empresa ? ev?.descripcion || '' : ''));
  const [descripcion,setDescripcion]= useState(ev?.descripcion || '');
  const [horaInicio, setHoraInicio] = useState(ev?.hora_inicio || '');
  const [horaFin,    setHoraFin]    = useState(ev?.hora_fin    || '');
  const [color,      setColor]      = useState(ev?.color       || '#00b8e3');
  const [guardando,  setGuardando]  = useState(false);

  const fechaLabel = modal.fecha.toLocaleDateString('es-CO', { weekday: 'long', day: 'numeric', month: 'long' });
  const fechaISO   = modal.fecha.toISOString().slice(0, 10);
  const COLORES    = ['#00b8e3','#6366f1','#10b981','#f59e0b','#ef4444','#8b5cf6','#ec4899'];

  if (!canEdit && ev) {
    const nombre = ev.empresa || ev.titulo || ev.descripcion || 'Evento';
    return (
      <div style={{ position: 'fixed', inset: 0, background: 'rgba(8,41,63,0.75)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
        <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 16, padding: 24, width: '100%', maxWidth: 440, boxShadow: '0 12px 48px rgba(0,0,0,0.3)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>
            <div>
              <div style={{ fontSize: 16, fontWeight: 800, color: C.text }}>{nombre}</div>
              <div style={{ fontSize: 12, color: C.muted, marginTop: 3, textTransform: 'capitalize' }}>{fechaLabel}</div>
            </div>
            <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: C.muted, fontSize: 22, lineHeight: 1, padding: 0 }}>x</button>
          </div>
          {(ev.hora_inicio || ev.hora_fin) && <div style={{ fontSize: 13, color: ev.color || C.accent, fontWeight: 800, marginBottom: 12 }}>{ev.hora_inicio}{ev.hora_fin ? ` - ${ev.hora_fin}` : ''}</div>}
          {ev.empresa && <div style={{ fontSize: 12, color: C.muted, marginBottom: 8 }}><b>Empresa:</b> {ev.empresa}</div>}
          <div style={{ fontSize: 12, fontWeight: 800, color: C.muted, marginBottom: 5 }}>Notas</div>
          <div style={{ background: '#f7fbff', border: `1px solid ${C.border}`, borderRadius: 8, padding: 12, color: C.text, whiteSpace: 'pre-wrap', minHeight: 48 }}>
            {ev.descripcion || 'Sin notas registradas'}
          </div>
          <button onClick={onClose} style={{ ...s.btn('#1e3a50'), marginTop: 14 }}>Cerrar</button>
        </div>
      </div>
    );
  }

  async function submit(e) {
    e.preventDefault();
    setGuardando(true);
    try { await onGuardar({ id: ev?.id, fecha: fechaISO, titulo: empresa ? '' : titulo, empresa, descripcion, hora_inicio: horaInicio, hora_fin: horaFin, color }); }
    finally { setGuardando(false); }
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(8,41,63,0.75)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 16, padding: 24, width: '100%', maxWidth: 440, boxShadow: '0 12px 48px rgba(0,0,0,0.3)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 }}>
          <div>
            <div style={{ fontSize: 15, fontWeight: 700, color: C.text }}>{ev ? 'Editar evento' : 'Nuevo evento'}</div>
            <div style={{ fontSize: 12, color: C.muted, marginTop: 3, textTransform: 'capitalize' }}>{fechaLabel}</div>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: C.muted, fontSize: 22, lineHeight: 1, padding: 0 }}>×</button>
        </div>
        <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div>
            <label style={s.label}>Empresa</label>
            <select value={empresa} onChange={e => setEmpresa(e.target.value)} style={s.select}>
              <option value="">— Sin empresa asignada —</option>
              {empresas.map(e => <option key={e.nombre} value={e.nombre}>{e.nombre}</option>)}
            </select>
          </div>
          {!empresa && (
            <div>
              <label style={s.label}>Nombre del evento</label>
              <input value={titulo} onChange={e => setTitulo(e.target.value)} style={s.input} placeholder="Ej: Festivo, capacitación, diligencia..." />
            </div>
          )}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
            <div>
              <label style={s.label}>Hora inicio</label>
              <input type="time" value={horaInicio} onChange={e => setHoraInicio(e.target.value)} style={s.input} />
            </div>
            <div>
              <label style={s.label}>Hora fin</label>
              <input type="time" value={horaFin} onChange={e => setHoraFin(e.target.value)} style={s.input} />
            </div>
          </div>
          <div>
            <label style={s.label}>Notas para el técnico</label>
            <textarea value={descripcion} onChange={e => setDescripcion(e.target.value)} rows={3} style={{ ...s.input, resize: 'vertical' }} placeholder="Actividades, indicaciones..." />
          </div>
          <div>
            <label style={s.label}>Color</label>
            <div style={{ display: 'flex', gap: 8 }}>
              {COLORES.map(c => (
                <button key={c} type="button" onClick={() => setColor(c)} style={{ width: 28, height: 28, borderRadius: '50%', background: c, border: color === c ? '3px solid #fff' : '3px solid transparent', outline: color === c ? `2px solid ${c}` : 'none', cursor: 'pointer', flexShrink: 0 }} />
              ))}
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
            <button type="submit" disabled={guardando} style={s.btn(C.accent)}>{guardando ? 'Guardando...' : ev ? 'Actualizar' : 'Guardar'}</button>
            <button type="button" onClick={onClose} style={s.btn('#1e3a50')}>Cancelar</button>
            {ev && <button type="button" onClick={() => onEliminar(ev.id)} style={{ ...s.btn('#ef4444'), marginLeft: 'auto' }}>Eliminar</button>}
          </div>
        </form>
      </div>
    </div>
  );
}

function TabProgramacion({ isAdmin, canEdit }) {
  const [vista,        setVista]       = useState('semana');
  const [fechaRef,     setFechaRef]    = useState(() => { const d = new Date(); d.setHours(0,0,0,0); return d; });
  const [eventos,      setEventos]     = useState([]);
  const [cargando,     setCargando]    = useState(false);
  const [usuarios,     setUsuarios]    = useState([]);
  const [usuarioSel,   setUsuarioSel]  = useState('');
  const [empresasDispo,setEmpresasDispo]= useState([]);
  const [modal,        setModal]       = useState(null);

  useEffect(() => {
    if (!isAdmin) return;
    fetch(`${API}/api/usuarios/tecnicos`, { headers: hdr() })
      .then(r => r.json())
      .then(d => { const l = Array.isArray(d) ? d : []; setUsuarios(l); setUsuarioSel(p => p || String(l[0]?.id || '')); })
      .catch(() => {});
  }, [isAdmin]);

  useEffect(() => {
    if (isAdmin && !usuarioSel) return;
    const qs = isAdmin && usuarioSel ? `?usuario_id=${usuarioSel}` : '';
    fetch(`${API}/api/empresas-lista${qs}`, { headers: hdr() })
      .then(r => r.json())
      .then(d => setEmpresasDispo(Array.isArray(d) ? d.filter(e => e.tecnico_visible) : []))
      .catch(() => {});
  }, [isAdmin, usuarioSel]);

  const toISO    = d => d.toISOString().slice(0, 10);
  const getLunes = d => { const r = new Date(d), dia = r.getDay(); r.setDate(r.getDate() + (dia === 0 ? -6 : 1 - dia)); return r; };

  const getRango = useCallback(() => {
    const d = new Date(fechaRef);
    if (vista === 'dia') return { ini: toISO(d), fin: toISO(d) };
    if (vista === 'semana') { const l = getLunes(d); const v = new Date(l); v.setDate(l.getDate() + 4); return { ini: toISO(l), fin: toISO(v) }; }
    return { ini: toISO(new Date(d.getFullYear(), d.getMonth(), 1)), fin: toISO(new Date(d.getFullYear(), d.getMonth() + 1, 0)) };
  }, [vista, fechaRef]);

  const cargar = useCallback(() => {
    const { ini, fin } = getRango();
    const uid = isAdmin && usuarioSel ? `&usuario_id=${usuarioSel}` : '';
    setCargando(true);
    fetch(`${API}/api/tecnico/programacion?fecha_inicio=${ini}&fecha_fin=${fin}${uid}`, { headers: hdr() })
      .then(r => r.json())
      .then(d => { setEventos(Array.isArray(d) ? d : []); setCargando(false); })
      .catch(() => setCargando(false));
  }, [getRango, isAdmin, usuarioSel]);

  useEffect(() => { if (!isAdmin || usuarioSel) cargar(); }, [cargar, isAdmin, usuarioSel]);

  const navegar = dir => {
    const d = new Date(fechaRef);
    if (vista === 'dia') d.setDate(d.getDate() + dir);
    else if (vista === 'semana') d.setDate(d.getDate() + dir * 7);
    else d.setMonth(d.getMonth() + dir);
    setFechaRef(d);
  };

  const hoyISO       = toISO(new Date());
  const evDelDia     = fecha => { const iso = toISO(fecha); return eventos.filter(e => safeDate(e.fecha) === iso); };

  async function guardarEvento(form) {
    try {
      if (form.id) {
        await fetch(`${API}/api/tecnico/programacion/${form.id}`, { method: 'PUT', headers: jsonHdr(), body: JSON.stringify(form) });
      } else {
        await fetch(`${API}/api/tecnico/programacion`, { method: 'POST', headers: jsonHdr(), body: JSON.stringify(isAdmin ? { ...form, usuario_id: parseInt(usuarioSel) } : form) });
      }
      setModal(null); cargar();
    } catch { alert('Error al guardar'); }
  }

  async function eliminarEvento(id) {
    if (!window.confirm('¿Eliminar este evento?')) return;
    await fetch(`${API}/api/tecnico/programacion/${id}`, { method: 'DELETE', headers: hdr() });
    setModal(null); cargar();
  }

  const tituloVista = () => {
    const d = fechaRef;
    if (vista === 'dia') return d.toLocaleDateString('es-CO', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
    if (vista === 'semana') {
      const l = getLunes(d); const v = new Date(l); v.setDate(l.getDate() + 4);
      const mismoMes = l.getMonth() === v.getMonth();
      const mesStr = mismoMes
        ? d.toLocaleDateString('es-CO', { month: 'long', year: 'numeric' })
        : `${l.toLocaleDateString('es-CO', { month: 'short' })} – ${v.toLocaleDateString('es-CO', { month: 'short', year: 'numeric' })}`;
      return `${l.getDate()} – ${v.getDate()} ${mesStr}`;
    }
    return d.toLocaleDateString('es-CO', { month: 'long', year: 'numeric' });
  };

  // ── Vista semana ──────────────────────────────────────────────────
  const renderSemana = () => {
    const lunes = getLunes(fechaRef);
    const dias  = Array.from({ length: 5 }, (_, i) => { const d = new Date(lunes); d.setDate(lunes.getDate() + i); return d; });
    return (
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 10, marginTop: 16 }}>
        {dias.map(dia => {
          const iso = toISO(dia); const evs = evDelDia(dia); const esHoy = iso === hoyISO;
          return (
            <div key={iso} style={{ background: C.card, border: `1.5px solid ${esHoy ? C.accent : C.border}`, borderRadius: 10, overflow: 'hidden', minHeight: 120 }}>
              <div style={{ padding: '8px 10px', background: esHoy ? C.accent : '#eef3f8', borderBottom: `1px solid ${C.border}` }}>
                <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', color: esHoy ? 'rgba(255,255,255,0.85)' : C.muted }}>
                  {dia.toLocaleDateString('es-CO', { weekday: 'short' })}
                </div>
                <div style={{ fontSize: 24, fontWeight: 800, color: esHoy ? '#fff' : C.text, lineHeight: 1.1 }}>{dia.getDate()}</div>
              </div>
              <div style={{ padding: '8px 8px 6px', display: 'flex', flexDirection: 'column', gap: 4 }}>
                {evs.map(ev => <EventoCard key={ev.id} evento={ev} compact onClick={() => setModal({ fecha: dia, evento: ev })} />)}
                {canEdit && (
                  <button onClick={() => setModal({ fecha: dia, evento: null })} style={{ background: 'none', border: `1px dashed ${C.border}`, borderRadius: 6, color: C.muted, fontSize: 11, padding: '5px 0', cursor: 'pointer', marginTop: evs.length ? 2 : 0 }}>
                    + Agregar
                  </button>
                )}
                {!canEdit && evs.length === 0 && <div style={{ fontSize: 11, color: C.muted, textAlign: 'center', padding: '8px 0' }}>—</div>}
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  // ── Vista mes ─────────────────────────────────────────────────────
  const renderMes = () => {
    const año = fechaRef.getFullYear(), mes = fechaRef.getMonth();
    const primerDia = new Date(año, mes, 1);
    const inicio    = new Date(primerDia);
    const diaW      = inicio.getDay();
    inicio.setDate(inicio.getDate() - (diaW === 0 ? 6 : diaW - 1));
    const celdas = []; const cur = new Date(inicio);
    while (celdas.length < 42) { celdas.push(new Date(cur)); cur.setDate(cur.getDate() + 1); }
    const HDR = ['Lun','Mar','Mié','Jue','Vie','Sáb','Dom'];
    return (
      <div style={{ marginTop: 16, border: `1px solid ${C.border}`, borderRadius: 10, overflow: 'hidden' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', borderBottom: `1px solid ${C.border}` }}>
          {HDR.map(d => <div key={d} style={{ padding: '9px 0', textAlign: 'center', fontSize: 11, fontWeight: 700, color: C.muted, textTransform: 'uppercase', letterSpacing: '0.05em', background: '#eef3f8' }}>{d}</div>)}
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 1, background: C.border }}>
          {celdas.map((dia, i) => {
            const iso = toISO(dia); const esHoy = iso === hoyISO;
            const esMes = dia.getMonth() === mes; const esFinSemana = dia.getDay() === 0 || dia.getDay() === 6;
            const evs   = evDelDia(dia);
            return (
              <div key={i} onClick={() => canEdit && esMes && !esFinSemana && setModal({ fecha: dia, evento: null })}
                style={{ background: esHoy ? 'rgba(0,184,227,0.08)' : (esMes ? C.card : '#f5f8fb'), padding: '6px 7px', minHeight: 72, cursor: canEdit && esMes && !esFinSemana ? 'pointer' : 'default' }}>
                <div style={{ fontSize: 12, fontWeight: esHoy ? 800 : 500, color: esHoy ? C.accent : (esMes ? C.text : C.muted), marginBottom: 3 }}>{dia.getDate()}</div>
                {evs.slice(0, 2).map(ev => (
                  <div key={ev.id} onClick={e => { e.stopPropagation(); setModal({ fecha: dia, evento: ev }); }}
                    style={{ fontSize: 10, fontWeight: 700, color: '#fff', background: ev.color || C.accent, borderRadius: 4, padding: '2px 5px', marginBottom: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', cursor: 'pointer' }}>
                    {ev.empresa || ev.titulo || ev.descripcion || 'Evento'}
                  </div>
                ))}
                {evs.length > 2 && <div style={{ fontSize: 10, color: C.muted }}>+{evs.length - 2} más</div>}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  // ── Vista día ──────────────────────────────────────────────────────
  const renderDia = () => {
    const evs = evDelDia(fechaRef);
    return (
      <div style={{ marginTop: 16 }}>
        {evs.length === 0 && (
          <div style={{ ...s.card, textAlign: 'center', color: C.muted, padding: 40 }}>
            {canEdit
              ? <><div style={{ marginBottom: 14 }}>Sin eventos para este día</div><button onClick={() => setModal({ fecha: fechaRef, evento: null })} style={s.btn(C.accent)}>+ Agregar evento</button></>
              : 'Sin actividades programadas para este día'}
          </div>
        )}
        {evs.map(ev => (
          <div key={ev.id} style={{ ...s.card, borderLeft: `4px solid ${ev.color || C.accent}`, cursor: 'pointer', marginBottom: 10 }}
            onClick={() => setModal({ fecha: fechaRef, evento: ev })}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <div style={{ fontSize: 16, fontWeight: 700, color: C.text }}>{ev.empresa || ev.titulo || ev.descripcion || 'Evento'}</div>
                {(ev.hora_inicio || ev.hora_fin) && (
                  <div style={{ fontSize: 12, color: ev.color || C.accent, fontWeight: 700, marginTop: 4 }}>
                    {ev.hora_inicio}{ev.hora_fin ? ` — ${ev.hora_fin}` : ''}
                  </div>
                )}
                {ev.descripcion && <div style={{ fontSize: 13, color: C.muted, marginTop: 8 }}>{ev.descripcion}</div>}
              </div>
              {canEdit && <div style={{ fontSize: 11, color: C.muted, flexShrink: 0, marginTop: 2 }}>Editar</div>}
            </div>
          </div>
        ))}
        {evs.length > 0 && canEdit && (
          <button onClick={() => setModal({ fecha: fechaRef, evento: null })} style={s.btn(C.accent)}>+ Agregar otro evento</button>
        )}
      </div>
    );
  };

  return (
    <div style={s.wrap}>
      {isAdmin && usuarios.length > 0 && (
        <div style={{ marginBottom: 16 }}>
          <label style={s.label}>Programación de</label>
          <select style={{ ...s.select, maxWidth: 320 }} value={usuarioSel} onChange={e => setUsuarioSel(e.target.value)}>
            {usuarios.map(u => <option key={u.id} value={u.id}>{u.nombre}</option>)}
          </select>
        </div>
      )}
      <div style={{ ...s.card, display: 'flex', alignItems: 'center', gap: 10, padding: '12px 16px', borderRadius: 10, flexWrap: 'wrap' }}>
        <div style={{ display: 'flex', gap: 4 }}>
          <button onClick={() => navegar(-1)} style={s.btnSm('#1e3a50')}>←</button>
          <button onClick={() => setFechaRef(new Date())} style={s.btnSm('#1e3a50')}>Hoy</button>
          <button onClick={() => navegar(1)} style={s.btnSm('#1e3a50')}>→</button>
        </div>
        <div style={{ flex: 1, textAlign: 'center', fontSize: 15, fontWeight: 700, color: C.text, textTransform: 'capitalize' }}>{tituloVista()}</div>
        <div style={{ display: 'flex', gap: 4 }}>
          {['dia','semana','mes'].map(v => (
            <button key={v} onClick={() => setVista(v)} style={s.btnSm(vista === v ? C.accent : '#1e3a50')}>
              {v === 'dia' ? 'Día' : v === 'semana' ? 'Semana' : 'Mes'}
            </button>
          ))}
        </div>
      </div>
      {cargando
        ? <div style={{ textAlign: 'center', padding: 48, color: C.muted }}>Cargando...</div>
        : <>{vista === 'semana' && renderSemana()}{vista === 'mes' && renderMes()}{vista === 'dia' && renderDia()}</>}
      {modal && (canEdit || modal.evento) && (
        <ModalEvento modal={modal} empresas={empresasDispo} onGuardar={guardarEvento} onEliminar={eliminarEvento} onClose={() => setModal(null)} canEdit={canEdit} />
      )}
    </div>
  );
}

// ─── Main TecnicoPage ─────────────────────────────────────────────────────────

export default function TecnicoPage({ user, onLogout, noHeader, initialTab, hideTabs = false, isAdmin: isAdminProp, theme, onToggleTheme }) {
  const [tab, setTabState] = useState(() => {
    if (initialTab) return initialTab;
    try { return localStorage.getItem('age_tecnico_tab') || 'registro'; } catch (_) { return 'registro'; }
  });
  const setTab = (next) => { try { localStorage.setItem('age_tecnico_tab', next); } catch (_) {} setTabState(next); };
  const [empresas, setEmpresas] = useState([]);
  const isAdmin = isAdminProp ?? user?.rol === 'admin';
  const permisos = Array.isArray(user?.permisos) ? user.permisos : [];
  const canDeleteInventory = isAdmin || permisos.includes('inventario.eliminar');
  const fichaCompleta = isAdmin || permisos.includes('module.clientes');
  const canEditProgramacion = isAdmin || permisos.includes('tecnico.programacion.editar');

  useEffect(() => {
    fetch(`${API}/api/empresas-lista`, { headers: hdr() })
      .then(r => r.json()).then(d => setEmpresas(Array.isArray(d) ? d : [])).catch(() => {});
  }, []);

  useEffect(() => {
    if (initialTab) setTabState(initialTab);
  }, [initialTab]);

  return (
    <div style={noHeader ? {} : s.page}>
      {!noHeader && (
        <div style={s.header}>
          <div style={{ flex: 1 }}>
            <h1 style={{ fontSize: 20, fontWeight: 700, color: C.accent, margin: 0 }}>Panel Técnico</h1>
            <div style={{ fontSize: 12, color: C.muted, marginTop: 2 }}>{user?.nombre || user?.correo}</div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            {onToggleTheme && <ThemeToggle theme={theme} onToggle={onToggleTheme} variant="nav" />}
            <button onClick={onLogout} style={{ ...s.btnSm('#183c59'), fontSize: 12 }}>Cerrar sesión</button>
          </div>
        </div>
      )}
      {!hideTabs && <div style={s.tabs(noHeader)}>
        <button style={s.tab(tab === 'registro')} onClick={() => setTab('registro')}>Registro</button>
        <button style={s.tab(tab === 'empresas')} onClick={() => setTab('empresas')}>Empresas</button>
        <button style={s.tab(tab === 'programacion')} onClick={() => setTab('programacion')}>Programación</button>
      </div>}

      {tab === 'registro' && (
        <>
          <TabRegistro isAdmin={isAdmin} />
          {isAdmin && <div style={{ maxWidth: 900, margin: '0 auto', padding: '0 16px 24px' }}><AdminRegistros empresas={empresas} /></div>}
        </>
      )}
      {tab === 'empresas'     && <TabEmpresas isAdmin={isAdmin} canDeleteInventory={canDeleteInventory} fichaCompleta={fichaCompleta} />}
      {tab === 'programacion' && <TabProgramacion isAdmin={isAdmin} canEdit={canEditProgramacion} />}
    </div>
  );
}
